"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_1 = require("graphql");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
/** unique or primary key constraints on table "archive_files" */
var ArchiveFilesConstraint;
(function (ArchiveFilesConstraint) {
    /** unique or primary key constraint */
    ArchiveFilesConstraint["archive_files_pkey"] = "archive_files_pkey";
})(ArchiveFilesConstraint = exports.ArchiveFilesConstraint || (exports.ArchiveFilesConstraint = {}));
/** select columns of table "archive_files" */
var ArchiveFilesSelectColumn;
(function (ArchiveFilesSelectColumn) {
    /** column name */
    ArchiveFilesSelectColumn["archive_job_id"] = "archive_job_id";
    /** column name */
    ArchiveFilesSelectColumn["asset_file_id"] = "asset_file_id";
    /** column name */
    ArchiveFilesSelectColumn["created_at"] = "created_at";
    /** column name */
    ArchiveFilesSelectColumn["id"] = "id";
    /** column name */
    ArchiveFilesSelectColumn["output_name"] = "output_name";
    /** column name */
    ArchiveFilesSelectColumn["output_path"] = "output_path";
    /** column name */
    ArchiveFilesSelectColumn["updated_at"] = "updated_at";
})(ArchiveFilesSelectColumn = exports.ArchiveFilesSelectColumn || (exports.ArchiveFilesSelectColumn = {}));
/** update columns of table "archive_files" */
var ArchiveFilesUpdateColumn;
(function (ArchiveFilesUpdateColumn) {
    /** column name */
    ArchiveFilesUpdateColumn["archive_job_id"] = "archive_job_id";
    /** column name */
    ArchiveFilesUpdateColumn["asset_file_id"] = "asset_file_id";
    /** column name */
    ArchiveFilesUpdateColumn["created_at"] = "created_at";
    /** column name */
    ArchiveFilesUpdateColumn["id"] = "id";
    /** column name */
    ArchiveFilesUpdateColumn["output_name"] = "output_name";
    /** column name */
    ArchiveFilesUpdateColumn["output_path"] = "output_path";
    /** column name */
    ArchiveFilesUpdateColumn["updated_at"] = "updated_at";
})(ArchiveFilesUpdateColumn = exports.ArchiveFilesUpdateColumn || (exports.ArchiveFilesUpdateColumn = {}));
/** unique or primary key constraints on table "archive_jobs" */
var ArchiveJobsConstraint;
(function (ArchiveJobsConstraint) {
    /** unique or primary key constraint */
    ArchiveJobsConstraint["archive_jobs_output_file_id_key"] = "archive_jobs_output_file_id_key";
    /** unique or primary key constraint */
    ArchiveJobsConstraint["archive_jobs_pkey"] = "archive_jobs_pkey";
})(ArchiveJobsConstraint = exports.ArchiveJobsConstraint || (exports.ArchiveJobsConstraint = {}));
/** select columns of table "archive_jobs" */
var ArchiveJobsSelectColumn;
(function (ArchiveJobsSelectColumn) {
    /** column name */
    ArchiveJobsSelectColumn["created_at"] = "created_at";
    /** column name */
    ArchiveJobsSelectColumn["error"] = "error";
    /** column name */
    ArchiveJobsSelectColumn["folder_id"] = "folder_id";
    /** column name */
    ArchiveJobsSelectColumn["id"] = "id";
    /** column name */
    ArchiveJobsSelectColumn["org_id"] = "org_id";
    /** column name */
    ArchiveJobsSelectColumn["output_file_id"] = "output_file_id";
    /** column name */
    ArchiveJobsSelectColumn["output_name"] = "output_name";
    /** column name */
    ArchiveJobsSelectColumn["output_warehouse_id"] = "output_warehouse_id";
    /** column name */
    ArchiveJobsSelectColumn["status"] = "status";
    /** column name */
    ArchiveJobsSelectColumn["updated_at"] = "updated_at";
})(ArchiveJobsSelectColumn = exports.ArchiveJobsSelectColumn || (exports.ArchiveJobsSelectColumn = {}));
/** update columns of table "archive_jobs" */
var ArchiveJobsUpdateColumn;
(function (ArchiveJobsUpdateColumn) {
    /** column name */
    ArchiveJobsUpdateColumn["created_at"] = "created_at";
    /** column name */
    ArchiveJobsUpdateColumn["error"] = "error";
    /** column name */
    ArchiveJobsUpdateColumn["folder_id"] = "folder_id";
    /** column name */
    ArchiveJobsUpdateColumn["id"] = "id";
    /** column name */
    ArchiveJobsUpdateColumn["org_id"] = "org_id";
    /** column name */
    ArchiveJobsUpdateColumn["output_file_id"] = "output_file_id";
    /** column name */
    ArchiveJobsUpdateColumn["output_name"] = "output_name";
    /** column name */
    ArchiveJobsUpdateColumn["output_warehouse_id"] = "output_warehouse_id";
    /** column name */
    ArchiveJobsUpdateColumn["status"] = "status";
    /** column name */
    ArchiveJobsUpdateColumn["updated_at"] = "updated_at";
})(ArchiveJobsUpdateColumn = exports.ArchiveJobsUpdateColumn || (exports.ArchiveJobsUpdateColumn = {}));
/** unique or primary key constraints on table "asset_file_types" */
var AssetFileTypesConstraint;
(function (AssetFileTypesConstraint) {
    /** unique or primary key constraint */
    AssetFileTypesConstraint["asset_file_types_pkey"] = "asset_file_types_pkey";
})(AssetFileTypesConstraint = exports.AssetFileTypesConstraint || (exports.AssetFileTypesConstraint = {}));
var AssetFileTypesEnum;
(function (AssetFileTypesEnum) {
    AssetFileTypesEnum["ARCHIVE"] = "ARCHIVE";
    AssetFileTypesEnum["IMAGE_THUMBNAIL"] = "IMAGE_THUMBNAIL";
    AssetFileTypesEnum["ORIGINAL"] = "ORIGINAL";
    AssetFileTypesEnum["TRANSCODED_VIDEO"] = "TRANSCODED_VIDEO";
    AssetFileTypesEnum["UNKNOWN"] = "UNKNOWN";
    AssetFileTypesEnum["VIDEO_THUMBNAIL"] = "VIDEO_THUMBNAIL";
})(AssetFileTypesEnum = exports.AssetFileTypesEnum || (exports.AssetFileTypesEnum = {}));
/** select columns of table "asset_file_types" */
var AssetFileTypesSelectColumn;
(function (AssetFileTypesSelectColumn) {
    /** column name */
    AssetFileTypesSelectColumn["type"] = "type";
})(AssetFileTypesSelectColumn = exports.AssetFileTypesSelectColumn || (exports.AssetFileTypesSelectColumn = {}));
/** update columns of table "asset_file_types" */
var AssetFileTypesUpdateColumn;
(function (AssetFileTypesUpdateColumn) {
    /** column name */
    AssetFileTypesUpdateColumn["type"] = "type";
})(AssetFileTypesUpdateColumn = exports.AssetFileTypesUpdateColumn || (exports.AssetFileTypesUpdateColumn = {}));
/** unique or primary key constraints on table "asset_files" */
var AssetFilesConstraint;
(function (AssetFilesConstraint) {
    /** unique or primary key constraint */
    AssetFilesConstraint["asset_files_pkey"] = "asset_files_pkey";
    /** unique or primary key constraint */
    AssetFilesConstraint["asset_files_storage_key_key"] = "asset_files_storage_key_key";
    /** unique or primary key constraint */
    AssetFilesConstraint["asset_files_transcoded_profile_key"] = "asset_files_transcoded_profile_key";
})(AssetFilesConstraint = exports.AssetFilesConstraint || (exports.AssetFilesConstraint = {}));
/** select columns of table "asset_files" */
var AssetFilesSelectColumn;
(function (AssetFilesSelectColumn) {
    /** column name */
    AssetFilesSelectColumn["created_at"] = "created_at";
    /** column name */
    AssetFilesSelectColumn["created_by"] = "created_by";
    /** column name */
    AssetFilesSelectColumn["id"] = "id";
    /** column name */
    AssetFilesSelectColumn["media_asset_id"] = "media_asset_id";
    /** column name */
    AssetFilesSelectColumn["mime_type"] = "mime_type";
    /** column name */
    AssetFilesSelectColumn["name"] = "name";
    /** column name */
    AssetFilesSelectColumn["org_id"] = "org_id";
    /** column name */
    AssetFilesSelectColumn["size"] = "size";
    /** column name */
    AssetFilesSelectColumn["storage_key"] = "storage_key";
    /** column name */
    AssetFilesSelectColumn["transcoded_profile_id"] = "transcoded_profile_id";
    /** column name */
    AssetFilesSelectColumn["type"] = "type";
    /** column name */
    AssetFilesSelectColumn["updated_at"] = "updated_at";
    /** column name */
    AssetFilesSelectColumn["warehouse_id"] = "warehouse_id";
})(AssetFilesSelectColumn = exports.AssetFilesSelectColumn || (exports.AssetFilesSelectColumn = {}));
/** update columns of table "asset_files" */
var AssetFilesUpdateColumn;
(function (AssetFilesUpdateColumn) {
    /** column name */
    AssetFilesUpdateColumn["created_at"] = "created_at";
    /** column name */
    AssetFilesUpdateColumn["created_by"] = "created_by";
    /** column name */
    AssetFilesUpdateColumn["id"] = "id";
    /** column name */
    AssetFilesUpdateColumn["media_asset_id"] = "media_asset_id";
    /** column name */
    AssetFilesUpdateColumn["mime_type"] = "mime_type";
    /** column name */
    AssetFilesUpdateColumn["name"] = "name";
    /** column name */
    AssetFilesUpdateColumn["org_id"] = "org_id";
    /** column name */
    AssetFilesUpdateColumn["size"] = "size";
    /** column name */
    AssetFilesUpdateColumn["storage_key"] = "storage_key";
    /** column name */
    AssetFilesUpdateColumn["transcoded_profile_id"] = "transcoded_profile_id";
    /** column name */
    AssetFilesUpdateColumn["type"] = "type";
    /** column name */
    AssetFilesUpdateColumn["updated_at"] = "updated_at";
    /** column name */
    AssetFilesUpdateColumn["warehouse_id"] = "warehouse_id";
})(AssetFilesUpdateColumn = exports.AssetFilesUpdateColumn || (exports.AssetFilesUpdateColumn = {}));
/** unique or primary key constraints on table "asset_metadata_field_values" */
var AssetMetadataFieldValuesConstraint;
(function (AssetMetadataFieldValuesConstraint) {
    /** unique or primary key constraint */
    AssetMetadataFieldValuesConstraint["asset_metadata_field_values_pkey"] = "asset_metadata_field_values_pkey";
})(AssetMetadataFieldValuesConstraint = exports.AssetMetadataFieldValuesConstraint || (exports.AssetMetadataFieldValuesConstraint = {}));
/** select columns of table "asset_metadata_field_values" */
var AssetMetadataFieldValuesSelectColumn;
(function (AssetMetadataFieldValuesSelectColumn) {
    /** column name */
    AssetMetadataFieldValuesSelectColumn["asset_id"] = "asset_id";
    /** column name */
    AssetMetadataFieldValuesSelectColumn["field_id"] = "field_id";
})(AssetMetadataFieldValuesSelectColumn = exports.AssetMetadataFieldValuesSelectColumn || (exports.AssetMetadataFieldValuesSelectColumn = {}));
/** update columns of table "asset_metadata_field_values" */
var AssetMetadataFieldValuesUpdateColumn;
(function (AssetMetadataFieldValuesUpdateColumn) {
    /** column name */
    AssetMetadataFieldValuesUpdateColumn["asset_id"] = "asset_id";
    /** column name */
    AssetMetadataFieldValuesUpdateColumn["field_id"] = "field_id";
})(AssetMetadataFieldValuesUpdateColumn = exports.AssetMetadataFieldValuesUpdateColumn || (exports.AssetMetadataFieldValuesUpdateColumn = {}));
/** unique or primary key constraints on table "asset_metadata_fields" */
var AssetMetadataFieldsConstraint;
(function (AssetMetadataFieldsConstraint) {
    /** unique or primary key constraint */
    AssetMetadataFieldsConstraint["asset_metadata_fields_pkey"] = "asset_metadata_fields_pkey";
})(AssetMetadataFieldsConstraint = exports.AssetMetadataFieldsConstraint || (exports.AssetMetadataFieldsConstraint = {}));
/** select columns of table "asset_metadata_fields" */
var AssetMetadataFieldsSelectColumn;
(function (AssetMetadataFieldsSelectColumn) {
    /** column name */
    AssetMetadataFieldsSelectColumn["created_at"] = "created_at";
    /** column name */
    AssetMetadataFieldsSelectColumn["id"] = "id";
    /** column name */
    AssetMetadataFieldsSelectColumn["name"] = "name";
    /** column name */
    AssetMetadataFieldsSelectColumn["options"] = "options";
    /** column name */
    AssetMetadataFieldsSelectColumn["org_id"] = "org_id";
    /** column name */
    AssetMetadataFieldsSelectColumn["type"] = "type";
    /** column name */
    AssetMetadataFieldsSelectColumn["updated_at"] = "updated_at";
})(AssetMetadataFieldsSelectColumn = exports.AssetMetadataFieldsSelectColumn || (exports.AssetMetadataFieldsSelectColumn = {}));
/** update columns of table "asset_metadata_fields" */
var AssetMetadataFieldsUpdateColumn;
(function (AssetMetadataFieldsUpdateColumn) {
    /** column name */
    AssetMetadataFieldsUpdateColumn["created_at"] = "created_at";
    /** column name */
    AssetMetadataFieldsUpdateColumn["id"] = "id";
    /** column name */
    AssetMetadataFieldsUpdateColumn["name"] = "name";
    /** column name */
    AssetMetadataFieldsUpdateColumn["options"] = "options";
    /** column name */
    AssetMetadataFieldsUpdateColumn["org_id"] = "org_id";
    /** column name */
    AssetMetadataFieldsUpdateColumn["type"] = "type";
    /** column name */
    AssetMetadataFieldsUpdateColumn["updated_at"] = "updated_at";
})(AssetMetadataFieldsUpdateColumn = exports.AssetMetadataFieldsUpdateColumn || (exports.AssetMetadataFieldsUpdateColumn = {}));
/** unique or primary key constraints on table "asset_metadata_types" */
var AssetMetadataTypesConstraint;
(function (AssetMetadataTypesConstraint) {
    /** unique or primary key constraint */
    AssetMetadataTypesConstraint["asset_metadata_types_pkey"] = "asset_metadata_types_pkey";
})(AssetMetadataTypesConstraint = exports.AssetMetadataTypesConstraint || (exports.AssetMetadataTypesConstraint = {}));
var AssetMetadataTypesEnum;
(function (AssetMetadataTypesEnum) {
    AssetMetadataTypesEnum["BOOLEAN"] = "BOOLEAN";
    AssetMetadataTypesEnum["DATE"] = "DATE";
    AssetMetadataTypesEnum["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    AssetMetadataTypesEnum["NUMBER"] = "NUMBER";
    AssetMetadataTypesEnum["SIMPLE_TEXT"] = "SIMPLE_TEXT";
    AssetMetadataTypesEnum["SINGLE_CHOICE"] = "SINGLE_CHOICE";
    AssetMetadataTypesEnum["TAG_LIST"] = "TAG_LIST";
})(AssetMetadataTypesEnum = exports.AssetMetadataTypesEnum || (exports.AssetMetadataTypesEnum = {}));
/** select columns of table "asset_metadata_types" */
var AssetMetadataTypesSelectColumn;
(function (AssetMetadataTypesSelectColumn) {
    /** column name */
    AssetMetadataTypesSelectColumn["type"] = "type";
})(AssetMetadataTypesSelectColumn = exports.AssetMetadataTypesSelectColumn || (exports.AssetMetadataTypesSelectColumn = {}));
/** update columns of table "asset_metadata_types" */
var AssetMetadataTypesUpdateColumn;
(function (AssetMetadataTypesUpdateColumn) {
    /** column name */
    AssetMetadataTypesUpdateColumn["type"] = "type";
})(AssetMetadataTypesUpdateColumn = exports.AssetMetadataTypesUpdateColumn || (exports.AssetMetadataTypesUpdateColumn = {}));
/** unique or primary key constraints on table "asset_metadata_values" */
var AssetMetadataValuesConstraint;
(function (AssetMetadataValuesConstraint) {
    /** unique or primary key constraint */
    AssetMetadataValuesConstraint["asset_metadata_values_pkey"] = "asset_metadata_values_pkey";
})(AssetMetadataValuesConstraint = exports.AssetMetadataValuesConstraint || (exports.AssetMetadataValuesConstraint = {}));
/** select columns of table "asset_metadata_values" */
var AssetMetadataValuesSelectColumn;
(function (AssetMetadataValuesSelectColumn) {
    /** column name */
    AssetMetadataValuesSelectColumn["asset_id"] = "asset_id";
    /** column name */
    AssetMetadataValuesSelectColumn["boolean_value"] = "boolean_value";
    /** column name */
    AssetMetadataValuesSelectColumn["date_value"] = "date_value";
    /** column name */
    AssetMetadataValuesSelectColumn["field_id"] = "field_id";
    /** column name */
    AssetMetadataValuesSelectColumn["id"] = "id";
    /** column name */
    AssetMetadataValuesSelectColumn["number_value"] = "number_value";
    /** column name */
    AssetMetadataValuesSelectColumn["text_value"] = "text_value";
    /** column name */
    AssetMetadataValuesSelectColumn["updated_at"] = "updated_at";
})(AssetMetadataValuesSelectColumn = exports.AssetMetadataValuesSelectColumn || (exports.AssetMetadataValuesSelectColumn = {}));
/** update columns of table "asset_metadata_values" */
var AssetMetadataValuesUpdateColumn;
(function (AssetMetadataValuesUpdateColumn) {
    /** column name */
    AssetMetadataValuesUpdateColumn["asset_id"] = "asset_id";
    /** column name */
    AssetMetadataValuesUpdateColumn["boolean_value"] = "boolean_value";
    /** column name */
    AssetMetadataValuesUpdateColumn["date_value"] = "date_value";
    /** column name */
    AssetMetadataValuesUpdateColumn["field_id"] = "field_id";
    /** column name */
    AssetMetadataValuesUpdateColumn["id"] = "id";
    /** column name */
    AssetMetadataValuesUpdateColumn["number_value"] = "number_value";
    /** column name */
    AssetMetadataValuesUpdateColumn["text_value"] = "text_value";
    /** column name */
    AssetMetadataValuesUpdateColumn["updated_at"] = "updated_at";
})(AssetMetadataValuesUpdateColumn = exports.AssetMetadataValuesUpdateColumn || (exports.AssetMetadataValuesUpdateColumn = {}));
/** unique or primary key constraints on table "cms.content_rows" */
var CmsContentRowsConstraint;
(function (CmsContentRowsConstraint) {
    /** unique or primary key constraint */
    CmsContentRowsConstraint["content_rows_pkey"] = "content_rows_pkey";
})(CmsContentRowsConstraint = exports.CmsContentRowsConstraint || (exports.CmsContentRowsConstraint = {}));
/** select columns of table "cms.content_rows" */
var CmsContentRowsSelectColumn;
(function (CmsContentRowsSelectColumn) {
    /** column name */
    CmsContentRowsSelectColumn["created_at"] = "created_at";
    /** column name */
    CmsContentRowsSelectColumn["default_locale"] = "default_locale";
    /** column name */
    CmsContentRowsSelectColumn["deleted_at"] = "deleted_at";
    /** column name */
    CmsContentRowsSelectColumn["id"] = "id";
    /** column name */
    CmsContentRowsSelectColumn["is_access_restricted"] = "is_access_restricted";
    /** column name */
    CmsContentRowsSelectColumn["locale_data"] = "locale_data";
    /** column name */
    CmsContentRowsSelectColumn["project_id"] = "project_id";
    /** column name */
    CmsContentRowsSelectColumn["revision"] = "revision";
    /** column name */
    CmsContentRowsSelectColumn["status"] = "status";
    /** column name */
    CmsContentRowsSelectColumn["type"] = "type";
    /** column name */
    CmsContentRowsSelectColumn["version"] = "version";
})(CmsContentRowsSelectColumn = exports.CmsContentRowsSelectColumn || (exports.CmsContentRowsSelectColumn = {}));
/** update columns of table "cms.content_rows" */
var CmsContentRowsUpdateColumn;
(function (CmsContentRowsUpdateColumn) {
    /** column name */
    CmsContentRowsUpdateColumn["created_at"] = "created_at";
    /** column name */
    CmsContentRowsUpdateColumn["default_locale"] = "default_locale";
    /** column name */
    CmsContentRowsUpdateColumn["deleted_at"] = "deleted_at";
    /** column name */
    CmsContentRowsUpdateColumn["id"] = "id";
    /** column name */
    CmsContentRowsUpdateColumn["is_access_restricted"] = "is_access_restricted";
    /** column name */
    CmsContentRowsUpdateColumn["locale_data"] = "locale_data";
    /** column name */
    CmsContentRowsUpdateColumn["project_id"] = "project_id";
    /** column name */
    CmsContentRowsUpdateColumn["revision"] = "revision";
    /** column name */
    CmsContentRowsUpdateColumn["status"] = "status";
    /** column name */
    CmsContentRowsUpdateColumn["type"] = "type";
    /** column name */
    CmsContentRowsUpdateColumn["version"] = "version";
})(CmsContentRowsUpdateColumn = exports.CmsContentRowsUpdateColumn || (exports.CmsContentRowsUpdateColumn = {}));
/** unique or primary key constraints on table "cms.content_schemas" */
var CmsContentSchemasConstraint;
(function (CmsContentSchemasConstraint) {
    /** unique or primary key constraint */
    CmsContentSchemasConstraint["content_schemas_pkey"] = "content_schemas_pkey";
    /** unique or primary key constraint */
    CmsContentSchemasConstraint["content_schemas_project_id_version_key"] = "content_schemas_project_id_version_key";
})(CmsContentSchemasConstraint = exports.CmsContentSchemasConstraint || (exports.CmsContentSchemasConstraint = {}));
/** select columns of table "cms.content_schemas" */
var CmsContentSchemasSelectColumn;
(function (CmsContentSchemasSelectColumn) {
    /** column name */
    CmsContentSchemasSelectColumn["created_at"] = "created_at";
    /** column name */
    CmsContentSchemasSelectColumn["id"] = "id";
    /** column name */
    CmsContentSchemasSelectColumn["project_id"] = "project_id";
    /** column name */
    CmsContentSchemasSelectColumn["schema_sdl"] = "schema_sdl";
    /** column name */
    CmsContentSchemasSelectColumn["updated_at"] = "updated_at";
    /** column name */
    CmsContentSchemasSelectColumn["version"] = "version";
})(CmsContentSchemasSelectColumn = exports.CmsContentSchemasSelectColumn || (exports.CmsContentSchemasSelectColumn = {}));
/** update columns of table "cms.content_schemas" */
var CmsContentSchemasUpdateColumn;
(function (CmsContentSchemasUpdateColumn) {
    /** column name */
    CmsContentSchemasUpdateColumn["created_at"] = "created_at";
    /** column name */
    CmsContentSchemasUpdateColumn["id"] = "id";
    /** column name */
    CmsContentSchemasUpdateColumn["project_id"] = "project_id";
    /** column name */
    CmsContentSchemasUpdateColumn["schema_sdl"] = "schema_sdl";
    /** column name */
    CmsContentSchemasUpdateColumn["updated_at"] = "updated_at";
    /** column name */
    CmsContentSchemasUpdateColumn["version"] = "version";
})(CmsContentSchemasUpdateColumn = exports.CmsContentSchemasUpdateColumn || (exports.CmsContentSchemasUpdateColumn = {}));
/** unique or primary key constraints on table "cms.locales" */
var CmsLocalesConstraint;
(function (CmsLocalesConstraint) {
    /** unique or primary key constraint */
    CmsLocalesConstraint["locales_pkey"] = "locales_pkey";
})(CmsLocalesConstraint = exports.CmsLocalesConstraint || (exports.CmsLocalesConstraint = {}));
var CmsLocalesEnum;
(function (CmsLocalesEnum) {
    CmsLocalesEnum["EN_US"] = "EN_US";
    CmsLocalesEnum["ET"] = "ET";
    CmsLocalesEnum["LT"] = "LT";
    CmsLocalesEnum["LV"] = "LV";
    CmsLocalesEnum["NO_LOCALE"] = "NO_LOCALE";
})(CmsLocalesEnum = exports.CmsLocalesEnum || (exports.CmsLocalesEnum = {}));
/** select columns of table "cms.locales" */
var CmsLocalesSelectColumn;
(function (CmsLocalesSelectColumn) {
    /** column name */
    CmsLocalesSelectColumn["locale"] = "locale";
})(CmsLocalesSelectColumn = exports.CmsLocalesSelectColumn || (exports.CmsLocalesSelectColumn = {}));
/** update columns of table "cms.locales" */
var CmsLocalesUpdateColumn;
(function (CmsLocalesUpdateColumn) {
    /** column name */
    CmsLocalesUpdateColumn["locale"] = "locale";
})(CmsLocalesUpdateColumn = exports.CmsLocalesUpdateColumn || (exports.CmsLocalesUpdateColumn = {}));
/** unique or primary key constraints on table "cms.publications" */
var CmsPublicationsConstraint;
(function (CmsPublicationsConstraint) {
    /** unique or primary key constraint */
    CmsPublicationsConstraint["publications_pkey"] = "publications_pkey";
})(CmsPublicationsConstraint = exports.CmsPublicationsConstraint || (exports.CmsPublicationsConstraint = {}));
/** select columns of table "cms.publications" */
var CmsPublicationsSelectColumn;
(function (CmsPublicationsSelectColumn) {
    /** column name */
    CmsPublicationsSelectColumn["created_at"] = "created_at";
    /** column name */
    CmsPublicationsSelectColumn["id"] = "id";
    /** column name */
    CmsPublicationsSelectColumn["project_id"] = "project_id";
    /** column name */
    CmsPublicationsSelectColumn["published_data"] = "published_data";
    /** column name */
    CmsPublicationsSelectColumn["publishing_webhook_url"] = "publishing_webhook_url";
    /** column name */
    CmsPublicationsSelectColumn["schema_sdl"] = "schema_sdl";
    /** column name */
    CmsPublicationsSelectColumn["status"] = "status";
    /** column name */
    CmsPublicationsSelectColumn["updated_at"] = "updated_at";
    /** column name */
    CmsPublicationsSelectColumn["version"] = "version";
})(CmsPublicationsSelectColumn = exports.CmsPublicationsSelectColumn || (exports.CmsPublicationsSelectColumn = {}));
/** update columns of table "cms.publications" */
var CmsPublicationsUpdateColumn;
(function (CmsPublicationsUpdateColumn) {
    /** column name */
    CmsPublicationsUpdateColumn["created_at"] = "created_at";
    /** column name */
    CmsPublicationsUpdateColumn["id"] = "id";
    /** column name */
    CmsPublicationsUpdateColumn["project_id"] = "project_id";
    /** column name */
    CmsPublicationsUpdateColumn["published_data"] = "published_data";
    /** column name */
    CmsPublicationsUpdateColumn["publishing_webhook_url"] = "publishing_webhook_url";
    /** column name */
    CmsPublicationsUpdateColumn["schema_sdl"] = "schema_sdl";
    /** column name */
    CmsPublicationsUpdateColumn["status"] = "status";
    /** column name */
    CmsPublicationsUpdateColumn["updated_at"] = "updated_at";
    /** column name */
    CmsPublicationsUpdateColumn["version"] = "version";
})(CmsPublicationsUpdateColumn = exports.CmsPublicationsUpdateColumn || (exports.CmsPublicationsUpdateColumn = {}));
/** unique or primary key constraints on table "fe.galleries" */
var FeGalleriesConstraint;
(function (FeGalleriesConstraint) {
    /** unique or primary key constraint */
    FeGalleriesConstraint["galleries_pkey"] = "galleries_pkey";
})(FeGalleriesConstraint = exports.FeGalleriesConstraint || (exports.FeGalleriesConstraint = {}));
/** select columns of table "fe.galleries" */
var FeGalleriesSelectColumn;
(function (FeGalleriesSelectColumn) {
    /** column name */
    FeGalleriesSelectColumn["folder_id"] = "folder_id";
    /** column name */
    FeGalleriesSelectColumn["id"] = "id";
    /** column name */
    FeGalleriesSelectColumn["updated_at"] = "updated_at";
})(FeGalleriesSelectColumn = exports.FeGalleriesSelectColumn || (exports.FeGalleriesSelectColumn = {}));
/** update columns of table "fe.galleries" */
var FeGalleriesUpdateColumn;
(function (FeGalleriesUpdateColumn) {
    /** column name */
    FeGalleriesUpdateColumn["folder_id"] = "folder_id";
    /** column name */
    FeGalleriesUpdateColumn["id"] = "id";
    /** column name */
    FeGalleriesUpdateColumn["updated_at"] = "updated_at";
})(FeGalleriesUpdateColumn = exports.FeGalleriesUpdateColumn || (exports.FeGalleriesUpdateColumn = {}));
/** unique or primary key constraints on table "fe.visitors" */
var FeVisitorsConstraint;
(function (FeVisitorsConstraint) {
    /** unique or primary key constraint */
    FeVisitorsConstraint["visitors_auth_user_id_auth_app_id_key"] = "visitors_auth_user_id_auth_app_id_key";
    /** unique or primary key constraint */
    FeVisitorsConstraint["visitors_pkey"] = "visitors_pkey";
})(FeVisitorsConstraint = exports.FeVisitorsConstraint || (exports.FeVisitorsConstraint = {}));
/** select columns of table "fe.visitors" */
var FeVisitorsSelectColumn;
(function (FeVisitorsSelectColumn) {
    /** column name */
    FeVisitorsSelectColumn["auth_app_id"] = "auth_app_id";
    /** column name */
    FeVisitorsSelectColumn["auth_user_id"] = "auth_user_id";
    /** column name */
    FeVisitorsSelectColumn["created_at"] = "created_at";
    /** column name */
    FeVisitorsSelectColumn["email"] = "email";
    /** column name */
    FeVisitorsSelectColumn["id"] = "id";
})(FeVisitorsSelectColumn = exports.FeVisitorsSelectColumn || (exports.FeVisitorsSelectColumn = {}));
/** update columns of table "fe.visitors" */
var FeVisitorsUpdateColumn;
(function (FeVisitorsUpdateColumn) {
    /** column name */
    FeVisitorsUpdateColumn["auth_app_id"] = "auth_app_id";
    /** column name */
    FeVisitorsUpdateColumn["auth_user_id"] = "auth_user_id";
    /** column name */
    FeVisitorsUpdateColumn["created_at"] = "created_at";
    /** column name */
    FeVisitorsUpdateColumn["email"] = "email";
    /** column name */
    FeVisitorsUpdateColumn["id"] = "id";
})(FeVisitorsUpdateColumn = exports.FeVisitorsUpdateColumn || (exports.FeVisitorsUpdateColumn = {}));
/** unique or primary key constraints on table "folder_hierarchy" */
var FolderHierarchyConstraint;
(function (FolderHierarchyConstraint) {
    /** unique or primary key constraint */
    FolderHierarchyConstraint["folder_hierarchy_parent_folder_id_child_folder_id_key"] = "folder_hierarchy_parent_folder_id_child_folder_id_key";
    /** unique or primary key constraint */
    FolderHierarchyConstraint["folder_hierarchy_pkey"] = "folder_hierarchy_pkey";
})(FolderHierarchyConstraint = exports.FolderHierarchyConstraint || (exports.FolderHierarchyConstraint = {}));
/** select columns of table "folder_hierarchy" */
var FolderHierarchySelectColumn;
(function (FolderHierarchySelectColumn) {
    /** column name */
    FolderHierarchySelectColumn["child_folder_id"] = "child_folder_id";
    /** column name */
    FolderHierarchySelectColumn["created_at"] = "created_at";
    /** column name */
    FolderHierarchySelectColumn["depth"] = "depth";
    /** column name */
    FolderHierarchySelectColumn["id"] = "id";
    /** column name */
    FolderHierarchySelectColumn["parent_folder_id"] = "parent_folder_id";
    /** column name */
    FolderHierarchySelectColumn["updated_at"] = "updated_at";
})(FolderHierarchySelectColumn = exports.FolderHierarchySelectColumn || (exports.FolderHierarchySelectColumn = {}));
/** update columns of table "folder_hierarchy" */
var FolderHierarchyUpdateColumn;
(function (FolderHierarchyUpdateColumn) {
    /** column name */
    FolderHierarchyUpdateColumn["child_folder_id"] = "child_folder_id";
    /** column name */
    FolderHierarchyUpdateColumn["created_at"] = "created_at";
    /** column name */
    FolderHierarchyUpdateColumn["depth"] = "depth";
    /** column name */
    FolderHierarchyUpdateColumn["id"] = "id";
    /** column name */
    FolderHierarchyUpdateColumn["parent_folder_id"] = "parent_folder_id";
    /** column name */
    FolderHierarchyUpdateColumn["updated_at"] = "updated_at";
})(FolderHierarchyUpdateColumn = exports.FolderHierarchyUpdateColumn || (exports.FolderHierarchyUpdateColumn = {}));
/** unique or primary key constraints on table "folders" */
var FoldersConstraint;
(function (FoldersConstraint) {
    /** unique or primary key constraint */
    FoldersConstraint["folders_pkey"] = "folders_pkey";
})(FoldersConstraint = exports.FoldersConstraint || (exports.FoldersConstraint = {}));
/** select columns of table "folders" */
var FoldersSelectColumn;
(function (FoldersSelectColumn) {
    /** column name */
    FoldersSelectColumn["created_at"] = "created_at";
    /** column name */
    FoldersSelectColumn["created_by"] = "created_by";
    /** column name */
    FoldersSelectColumn["deleted_at"] = "deleted_at";
    /** column name */
    FoldersSelectColumn["description"] = "description";
    /** column name */
    FoldersSelectColumn["id"] = "id";
    /** column name */
    FoldersSelectColumn["name"] = "name";
    /** column name */
    FoldersSelectColumn["org_id"] = "org_id";
    /** column name */
    FoldersSelectColumn["parent_id"] = "parent_id";
    /** column name */
    FoldersSelectColumn["updated_at"] = "updated_at";
})(FoldersSelectColumn = exports.FoldersSelectColumn || (exports.FoldersSelectColumn = {}));
/** update columns of table "folders" */
var FoldersUpdateColumn;
(function (FoldersUpdateColumn) {
    /** column name */
    FoldersUpdateColumn["created_at"] = "created_at";
    /** column name */
    FoldersUpdateColumn["created_by"] = "created_by";
    /** column name */
    FoldersUpdateColumn["deleted_at"] = "deleted_at";
    /** column name */
    FoldersUpdateColumn["description"] = "description";
    /** column name */
    FoldersUpdateColumn["id"] = "id";
    /** column name */
    FoldersUpdateColumn["name"] = "name";
    /** column name */
    FoldersUpdateColumn["org_id"] = "org_id";
    /** column name */
    FoldersUpdateColumn["parent_id"] = "parent_id";
    /** column name */
    FoldersUpdateColumn["updated_at"] = "updated_at";
})(FoldersUpdateColumn = exports.FoldersUpdateColumn || (exports.FoldersUpdateColumn = {}));
/** unique or primary key constraints on table "image_thumbnail_jobs" */
var ImageThumbnailJobsConstraint;
(function (ImageThumbnailJobsConstraint) {
    /** unique or primary key constraint */
    ImageThumbnailJobsConstraint["image_thumbnail_jobs_pkey"] = "image_thumbnail_jobs_pkey";
})(ImageThumbnailJobsConstraint = exports.ImageThumbnailJobsConstraint || (exports.ImageThumbnailJobsConstraint = {}));
/** select columns of table "image_thumbnail_jobs" */
var ImageThumbnailJobsSelectColumn;
(function (ImageThumbnailJobsSelectColumn) {
    /** column name */
    ImageThumbnailJobsSelectColumn["asset_file_id"] = "asset_file_id";
    /** column name */
    ImageThumbnailJobsSelectColumn["id"] = "id";
    /** column name */
    ImageThumbnailJobsSelectColumn["outputs"] = "outputs";
    /** column name */
    ImageThumbnailJobsSelectColumn["status"] = "status";
})(ImageThumbnailJobsSelectColumn = exports.ImageThumbnailJobsSelectColumn || (exports.ImageThumbnailJobsSelectColumn = {}));
/** update columns of table "image_thumbnail_jobs" */
var ImageThumbnailJobsUpdateColumn;
(function (ImageThumbnailJobsUpdateColumn) {
    /** column name */
    ImageThumbnailJobsUpdateColumn["asset_file_id"] = "asset_file_id";
    /** column name */
    ImageThumbnailJobsUpdateColumn["id"] = "id";
    /** column name */
    ImageThumbnailJobsUpdateColumn["outputs"] = "outputs";
    /** column name */
    ImageThumbnailJobsUpdateColumn["status"] = "status";
})(ImageThumbnailJobsUpdateColumn = exports.ImageThumbnailJobsUpdateColumn || (exports.ImageThumbnailJobsUpdateColumn = {}));
/** unique or primary key constraints on table "image_thumbnails" */
var ImageThumbnailsConstraint;
(function (ImageThumbnailsConstraint) {
    /** unique or primary key constraint */
    ImageThumbnailsConstraint["image_thumbnails_pkey"] = "image_thumbnails_pkey";
})(ImageThumbnailsConstraint = exports.ImageThumbnailsConstraint || (exports.ImageThumbnailsConstraint = {}));
/** select columns of table "image_thumbnails" */
var ImageThumbnailsSelectColumn;
(function (ImageThumbnailsSelectColumn) {
    /** column name */
    ImageThumbnailsSelectColumn["height"] = "height";
    /** column name */
    ImageThumbnailsSelectColumn["original_file_id"] = "original_file_id";
    /** column name */
    ImageThumbnailsSelectColumn["thumbnail_file_id"] = "thumbnail_file_id";
    /** column name */
    ImageThumbnailsSelectColumn["width"] = "width";
})(ImageThumbnailsSelectColumn = exports.ImageThumbnailsSelectColumn || (exports.ImageThumbnailsSelectColumn = {}));
/** update columns of table "image_thumbnails" */
var ImageThumbnailsUpdateColumn;
(function (ImageThumbnailsUpdateColumn) {
    /** column name */
    ImageThumbnailsUpdateColumn["height"] = "height";
    /** column name */
    ImageThumbnailsUpdateColumn["original_file_id"] = "original_file_id";
    /** column name */
    ImageThumbnailsUpdateColumn["thumbnail_file_id"] = "thumbnail_file_id";
    /** column name */
    ImageThumbnailsUpdateColumn["width"] = "width";
})(ImageThumbnailsUpdateColumn = exports.ImageThumbnailsUpdateColumn || (exports.ImageThumbnailsUpdateColumn = {}));
/** unique or primary key constraints on table "job_status_types" */
var JobStatusTypesConstraint;
(function (JobStatusTypesConstraint) {
    /** unique or primary key constraint */
    JobStatusTypesConstraint["job_status_types_pkey"] = "job_status_types_pkey";
})(JobStatusTypesConstraint = exports.JobStatusTypesConstraint || (exports.JobStatusTypesConstraint = {}));
var JobStatusTypesEnum;
(function (JobStatusTypesEnum) {
    JobStatusTypesEnum["FAILED"] = "FAILED";
    JobStatusTypesEnum["FINISHED"] = "FINISHED";
    JobStatusTypesEnum["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    JobStatusTypesEnum["PROCESSING"] = "PROCESSING";
    JobStatusTypesEnum["WAITING_FOR_PROCESSING"] = "WAITING_FOR_PROCESSING";
})(JobStatusTypesEnum = exports.JobStatusTypesEnum || (exports.JobStatusTypesEnum = {}));
/** select columns of table "job_status_types" */
var JobStatusTypesSelectColumn;
(function (JobStatusTypesSelectColumn) {
    /** column name */
    JobStatusTypesSelectColumn["type"] = "type";
})(JobStatusTypesSelectColumn = exports.JobStatusTypesSelectColumn || (exports.JobStatusTypesSelectColumn = {}));
/** update columns of table "job_status_types" */
var JobStatusTypesUpdateColumn;
(function (JobStatusTypesUpdateColumn) {
    /** column name */
    JobStatusTypesUpdateColumn["type"] = "type";
})(JobStatusTypesUpdateColumn = exports.JobStatusTypesUpdateColumn || (exports.JobStatusTypesUpdateColumn = {}));
/** unique or primary key constraints on table "media_asset_types" */
var MediaAssetTypesConstraint;
(function (MediaAssetTypesConstraint) {
    /** unique or primary key constraint */
    MediaAssetTypesConstraint["media_asset_types_pkey"] = "media_asset_types_pkey";
})(MediaAssetTypesConstraint = exports.MediaAssetTypesConstraint || (exports.MediaAssetTypesConstraint = {}));
var MediaAssetTypesEnum;
(function (MediaAssetTypesEnum) {
    MediaAssetTypesEnum["AUDIO"] = "AUDIO";
    MediaAssetTypesEnum["FILE"] = "FILE";
    MediaAssetTypesEnum["IMAGE"] = "IMAGE";
    MediaAssetTypesEnum["VIDEO"] = "VIDEO";
})(MediaAssetTypesEnum = exports.MediaAssetTypesEnum || (exports.MediaAssetTypesEnum = {}));
/** select columns of table "media_asset_types" */
var MediaAssetTypesSelectColumn;
(function (MediaAssetTypesSelectColumn) {
    /** column name */
    MediaAssetTypesSelectColumn["type"] = "type";
})(MediaAssetTypesSelectColumn = exports.MediaAssetTypesSelectColumn || (exports.MediaAssetTypesSelectColumn = {}));
/** update columns of table "media_asset_types" */
var MediaAssetTypesUpdateColumn;
(function (MediaAssetTypesUpdateColumn) {
    /** column name */
    MediaAssetTypesUpdateColumn["type"] = "type";
})(MediaAssetTypesUpdateColumn = exports.MediaAssetTypesUpdateColumn || (exports.MediaAssetTypesUpdateColumn = {}));
/** unique or primary key constraints on table "media_assets" */
var MediaAssetsConstraint;
(function (MediaAssetsConstraint) {
    /** unique or primary key constraint */
    MediaAssetsConstraint["media_assets_pkey"] = "media_assets_pkey";
})(MediaAssetsConstraint = exports.MediaAssetsConstraint || (exports.MediaAssetsConstraint = {}));
/** select columns of table "media_assets" */
var MediaAssetsSelectColumn;
(function (MediaAssetsSelectColumn) {
    /** column name */
    MediaAssetsSelectColumn["created_at"] = "created_at";
    /** column name */
    MediaAssetsSelectColumn["created_by"] = "created_by";
    /** column name */
    MediaAssetsSelectColumn["deleted_at"] = "deleted_at";
    /** column name */
    MediaAssetsSelectColumn["description"] = "description";
    /** column name */
    MediaAssetsSelectColumn["folder_id"] = "folder_id";
    /** column name */
    MediaAssetsSelectColumn["id"] = "id";
    /** column name */
    MediaAssetsSelectColumn["name"] = "name";
    /** column name */
    MediaAssetsSelectColumn["org_id"] = "org_id";
    /** column name */
    MediaAssetsSelectColumn["type"] = "type";
    /** column name */
    MediaAssetsSelectColumn["updated_at"] = "updated_at";
})(MediaAssetsSelectColumn = exports.MediaAssetsSelectColumn || (exports.MediaAssetsSelectColumn = {}));
/** update columns of table "media_assets" */
var MediaAssetsUpdateColumn;
(function (MediaAssetsUpdateColumn) {
    /** column name */
    MediaAssetsUpdateColumn["created_at"] = "created_at";
    /** column name */
    MediaAssetsUpdateColumn["created_by"] = "created_by";
    /** column name */
    MediaAssetsUpdateColumn["deleted_at"] = "deleted_at";
    /** column name */
    MediaAssetsUpdateColumn["description"] = "description";
    /** column name */
    MediaAssetsUpdateColumn["folder_id"] = "folder_id";
    /** column name */
    MediaAssetsUpdateColumn["id"] = "id";
    /** column name */
    MediaAssetsUpdateColumn["name"] = "name";
    /** column name */
    MediaAssetsUpdateColumn["org_id"] = "org_id";
    /** column name */
    MediaAssetsUpdateColumn["type"] = "type";
    /** column name */
    MediaAssetsUpdateColumn["updated_at"] = "updated_at";
})(MediaAssetsUpdateColumn = exports.MediaAssetsUpdateColumn || (exports.MediaAssetsUpdateColumn = {}));
/** unique or primary key constraints on table "meta_boolean_values" */
var MetaBooleanValuesConstraint;
(function (MetaBooleanValuesConstraint) {
    /** unique or primary key constraint */
    MetaBooleanValuesConstraint["meta_boolean_values_pkey"] = "meta_boolean_values_pkey";
})(MetaBooleanValuesConstraint = exports.MetaBooleanValuesConstraint || (exports.MetaBooleanValuesConstraint = {}));
/** select columns of table "meta_boolean_values" */
var MetaBooleanValuesSelectColumn;
(function (MetaBooleanValuesSelectColumn) {
    /** column name */
    MetaBooleanValuesSelectColumn["field_values_id"] = "field_values_id";
    /** column name */
    MetaBooleanValuesSelectColumn["id"] = "id";
    /** column name */
    MetaBooleanValuesSelectColumn["value"] = "value";
})(MetaBooleanValuesSelectColumn = exports.MetaBooleanValuesSelectColumn || (exports.MetaBooleanValuesSelectColumn = {}));
/** update columns of table "meta_boolean_values" */
var MetaBooleanValuesUpdateColumn;
(function (MetaBooleanValuesUpdateColumn) {
    /** column name */
    MetaBooleanValuesUpdateColumn["field_values_id"] = "field_values_id";
    /** column name */
    MetaBooleanValuesUpdateColumn["id"] = "id";
    /** column name */
    MetaBooleanValuesUpdateColumn["value"] = "value";
})(MetaBooleanValuesUpdateColumn = exports.MetaBooleanValuesUpdateColumn || (exports.MetaBooleanValuesUpdateColumn = {}));
/** unique or primary key constraints on table "meta_date_values" */
var MetaDateValuesConstraint;
(function (MetaDateValuesConstraint) {
    /** unique or primary key constraint */
    MetaDateValuesConstraint["meta_date_values_pkey"] = "meta_date_values_pkey";
})(MetaDateValuesConstraint = exports.MetaDateValuesConstraint || (exports.MetaDateValuesConstraint = {}));
/** select columns of table "meta_date_values" */
var MetaDateValuesSelectColumn;
(function (MetaDateValuesSelectColumn) {
    /** column name */
    MetaDateValuesSelectColumn["field_values_id"] = "field_values_id";
    /** column name */
    MetaDateValuesSelectColumn["id"] = "id";
    /** column name */
    MetaDateValuesSelectColumn["value"] = "value";
})(MetaDateValuesSelectColumn = exports.MetaDateValuesSelectColumn || (exports.MetaDateValuesSelectColumn = {}));
/** update columns of table "meta_date_values" */
var MetaDateValuesUpdateColumn;
(function (MetaDateValuesUpdateColumn) {
    /** column name */
    MetaDateValuesUpdateColumn["field_values_id"] = "field_values_id";
    /** column name */
    MetaDateValuesUpdateColumn["id"] = "id";
    /** column name */
    MetaDateValuesUpdateColumn["value"] = "value";
})(MetaDateValuesUpdateColumn = exports.MetaDateValuesUpdateColumn || (exports.MetaDateValuesUpdateColumn = {}));
/** unique or primary key constraints on table "meta_field_values" */
var MetaFieldValuesConstraint;
(function (MetaFieldValuesConstraint) {
    /** unique or primary key constraint */
    MetaFieldValuesConstraint["meta_field_values_field_id_asset_id_key"] = "meta_field_values_field_id_asset_id_key";
    /** unique or primary key constraint */
    MetaFieldValuesConstraint["meta_field_values_pkey"] = "meta_field_values_pkey";
})(MetaFieldValuesConstraint = exports.MetaFieldValuesConstraint || (exports.MetaFieldValuesConstraint = {}));
/** select columns of table "meta_field_values" */
var MetaFieldValuesSelectColumn;
(function (MetaFieldValuesSelectColumn) {
    /** column name */
    MetaFieldValuesSelectColumn["asset_id"] = "asset_id";
    /** column name */
    MetaFieldValuesSelectColumn["field_id"] = "field_id";
    /** column name */
    MetaFieldValuesSelectColumn["id"] = "id";
})(MetaFieldValuesSelectColumn = exports.MetaFieldValuesSelectColumn || (exports.MetaFieldValuesSelectColumn = {}));
/** update columns of table "meta_field_values" */
var MetaFieldValuesUpdateColumn;
(function (MetaFieldValuesUpdateColumn) {
    /** column name */
    MetaFieldValuesUpdateColumn["asset_id"] = "asset_id";
    /** column name */
    MetaFieldValuesUpdateColumn["field_id"] = "field_id";
    /** column name */
    MetaFieldValuesUpdateColumn["id"] = "id";
})(MetaFieldValuesUpdateColumn = exports.MetaFieldValuesUpdateColumn || (exports.MetaFieldValuesUpdateColumn = {}));
/** unique or primary key constraints on table "meta_number_values" */
var MetaNumberValuesConstraint;
(function (MetaNumberValuesConstraint) {
    /** unique or primary key constraint */
    MetaNumberValuesConstraint["meta_number_values_pkey"] = "meta_number_values_pkey";
})(MetaNumberValuesConstraint = exports.MetaNumberValuesConstraint || (exports.MetaNumberValuesConstraint = {}));
/** select columns of table "meta_number_values" */
var MetaNumberValuesSelectColumn;
(function (MetaNumberValuesSelectColumn) {
    /** column name */
    MetaNumberValuesSelectColumn["field_values_id"] = "field_values_id";
    /** column name */
    MetaNumberValuesSelectColumn["id"] = "id";
    /** column name */
    MetaNumberValuesSelectColumn["value"] = "value";
})(MetaNumberValuesSelectColumn = exports.MetaNumberValuesSelectColumn || (exports.MetaNumberValuesSelectColumn = {}));
/** update columns of table "meta_number_values" */
var MetaNumberValuesUpdateColumn;
(function (MetaNumberValuesUpdateColumn) {
    /** column name */
    MetaNumberValuesUpdateColumn["field_values_id"] = "field_values_id";
    /** column name */
    MetaNumberValuesUpdateColumn["id"] = "id";
    /** column name */
    MetaNumberValuesUpdateColumn["value"] = "value";
})(MetaNumberValuesUpdateColumn = exports.MetaNumberValuesUpdateColumn || (exports.MetaNumberValuesUpdateColumn = {}));
/** unique or primary key constraints on table "meta_text_values" */
var MetaTextValuesConstraint;
(function (MetaTextValuesConstraint) {
    /** unique or primary key constraint */
    MetaTextValuesConstraint["meta_text_values_pkey"] = "meta_text_values_pkey";
})(MetaTextValuesConstraint = exports.MetaTextValuesConstraint || (exports.MetaTextValuesConstraint = {}));
/** select columns of table "meta_text_values" */
var MetaTextValuesSelectColumn;
(function (MetaTextValuesSelectColumn) {
    /** column name */
    MetaTextValuesSelectColumn["field_values_id"] = "field_values_id";
    /** column name */
    MetaTextValuesSelectColumn["id"] = "id";
    /** column name */
    MetaTextValuesSelectColumn["value"] = "value";
})(MetaTextValuesSelectColumn = exports.MetaTextValuesSelectColumn || (exports.MetaTextValuesSelectColumn = {}));
/** update columns of table "meta_text_values" */
var MetaTextValuesUpdateColumn;
(function (MetaTextValuesUpdateColumn) {
    /** column name */
    MetaTextValuesUpdateColumn["field_values_id"] = "field_values_id";
    /** column name */
    MetaTextValuesUpdateColumn["id"] = "id";
    /** column name */
    MetaTextValuesUpdateColumn["value"] = "value";
})(MetaTextValuesUpdateColumn = exports.MetaTextValuesUpdateColumn || (exports.MetaTextValuesUpdateColumn = {}));
/** unique or primary key constraints on table "migration.jobs" */
var MigrationJobsConstraint;
(function (MigrationJobsConstraint) {
    /** unique or primary key constraint */
    MigrationJobsConstraint["jobs_pkey"] = "jobs_pkey";
})(MigrationJobsConstraint = exports.MigrationJobsConstraint || (exports.MigrationJobsConstraint = {}));
/** select columns of table "migration.jobs" */
var MigrationJobsSelectColumn;
(function (MigrationJobsSelectColumn) {
    /** column name */
    MigrationJobsSelectColumn["id"] = "id";
    /** column name */
    MigrationJobsSelectColumn["status"] = "status";
})(MigrationJobsSelectColumn = exports.MigrationJobsSelectColumn || (exports.MigrationJobsSelectColumn = {}));
/** update columns of table "migration.jobs" */
var MigrationJobsUpdateColumn;
(function (MigrationJobsUpdateColumn) {
    /** column name */
    MigrationJobsUpdateColumn["id"] = "id";
    /** column name */
    MigrationJobsUpdateColumn["status"] = "status";
})(MigrationJobsUpdateColumn = exports.MigrationJobsUpdateColumn || (exports.MigrationJobsUpdateColumn = {}));
/** unique or primary key constraints on table "oauth_scopes" */
var OauthScopesConstraint;
(function (OauthScopesConstraint) {
    /** unique or primary key constraint */
    OauthScopesConstraint["oauth_scopes_pkey"] = "oauth_scopes_pkey";
})(OauthScopesConstraint = exports.OauthScopesConstraint || (exports.OauthScopesConstraint = {}));
/** select columns of table "oauth_scopes" */
var OauthScopesSelectColumn;
(function (OauthScopesSelectColumn) {
    /** column name */
    OauthScopesSelectColumn["scope"] = "scope";
})(OauthScopesSelectColumn = exports.OauthScopesSelectColumn || (exports.OauthScopesSelectColumn = {}));
/** update columns of table "oauth_scopes" */
var OauthScopesUpdateColumn;
(function (OauthScopesUpdateColumn) {
    /** column name */
    OauthScopesUpdateColumn["scope"] = "scope";
})(OauthScopesUpdateColumn = exports.OauthScopesUpdateColumn || (exports.OauthScopesUpdateColumn = {}));
/** column ordering options */
var OrderBy;
(function (OrderBy) {
    /** in the ascending order, nulls last */
    OrderBy["asc"] = "asc";
    /** in the ascending order, nulls first */
    OrderBy["asc_nulls_first"] = "asc_nulls_first";
    /** in the ascending order, nulls last */
    OrderBy["asc_nulls_last"] = "asc_nulls_last";
    /** in the descending order, nulls first */
    OrderBy["desc"] = "desc";
    /** in the descending order, nulls first */
    OrderBy["desc_nulls_first"] = "desc_nulls_first";
    /** in the descending order, nulls last */
    OrderBy["desc_nulls_last"] = "desc_nulls_last";
})(OrderBy = exports.OrderBy || (exports.OrderBy = {}));
/** unique or primary key constraints on table "org_member_invites" */
var OrgMemberInvitesConstraint;
(function (OrgMemberInvitesConstraint) {
    /** unique or primary key constraint */
    OrgMemberInvitesConstraint["org_member_invites_pkey"] = "org_member_invites_pkey";
})(OrgMemberInvitesConstraint = exports.OrgMemberInvitesConstraint || (exports.OrgMemberInvitesConstraint = {}));
/** select columns of table "org_member_invites" */
var OrgMemberInvitesSelectColumn;
(function (OrgMemberInvitesSelectColumn) {
    /** column name */
    OrgMemberInvitesSelectColumn["created_at"] = "created_at";
    /** column name */
    OrgMemberInvitesSelectColumn["id"] = "id";
    /** column name */
    OrgMemberInvitesSelectColumn["invitee_email"] = "invitee_email";
    /** column name */
    OrgMemberInvitesSelectColumn["inviter_user_id"] = "inviter_user_id";
    /** column name */
    OrgMemberInvitesSelectColumn["is_used"] = "is_used";
    /** column name */
    OrgMemberInvitesSelectColumn["org_id"] = "org_id";
    /** column name */
    OrgMemberInvitesSelectColumn["updated_at"] = "updated_at";
})(OrgMemberInvitesSelectColumn = exports.OrgMemberInvitesSelectColumn || (exports.OrgMemberInvitesSelectColumn = {}));
/** update columns of table "org_member_invites" */
var OrgMemberInvitesUpdateColumn;
(function (OrgMemberInvitesUpdateColumn) {
    /** column name */
    OrgMemberInvitesUpdateColumn["created_at"] = "created_at";
    /** column name */
    OrgMemberInvitesUpdateColumn["id"] = "id";
    /** column name */
    OrgMemberInvitesUpdateColumn["invitee_email"] = "invitee_email";
    /** column name */
    OrgMemberInvitesUpdateColumn["inviter_user_id"] = "inviter_user_id";
    /** column name */
    OrgMemberInvitesUpdateColumn["is_used"] = "is_used";
    /** column name */
    OrgMemberInvitesUpdateColumn["org_id"] = "org_id";
    /** column name */
    OrgMemberInvitesUpdateColumn["updated_at"] = "updated_at";
})(OrgMemberInvitesUpdateColumn = exports.OrgMemberInvitesUpdateColumn || (exports.OrgMemberInvitesUpdateColumn = {}));
/** unique or primary key constraints on table "org_members" */
var OrgMembersConstraint;
(function (OrgMembersConstraint) {
    /** unique or primary key constraint */
    OrgMembersConstraint["org_members_id_user_id_key"] = "org_members_id_user_id_key";
    /** unique or primary key constraint */
    OrgMembersConstraint["org_members_org_id_user_id_key"] = "org_members_org_id_user_id_key";
    /** unique or primary key constraint */
    OrgMembersConstraint["org_members_pkey"] = "org_members_pkey";
})(OrgMembersConstraint = exports.OrgMembersConstraint || (exports.OrgMembersConstraint = {}));
/** select columns of table "org_members" */
var OrgMembersSelectColumn;
(function (OrgMembersSelectColumn) {
    /** column name */
    OrgMembersSelectColumn["created_at"] = "created_at";
    /** column name */
    OrgMembersSelectColumn["id"] = "id";
    /** column name */
    OrgMembersSelectColumn["org_id"] = "org_id";
    /** column name */
    OrgMembersSelectColumn["updated_at"] = "updated_at";
    /** column name */
    OrgMembersSelectColumn["user_id"] = "user_id";
})(OrgMembersSelectColumn = exports.OrgMembersSelectColumn || (exports.OrgMembersSelectColumn = {}));
/** update columns of table "org_members" */
var OrgMembersUpdateColumn;
(function (OrgMembersUpdateColumn) {
    /** column name */
    OrgMembersUpdateColumn["created_at"] = "created_at";
    /** column name */
    OrgMembersUpdateColumn["id"] = "id";
    /** column name */
    OrgMembersUpdateColumn["org_id"] = "org_id";
    /** column name */
    OrgMembersUpdateColumn["updated_at"] = "updated_at";
    /** column name */
    OrgMembersUpdateColumn["user_id"] = "user_id";
})(OrgMembersUpdateColumn = exports.OrgMembersUpdateColumn || (exports.OrgMembersUpdateColumn = {}));
/** unique or primary key constraints on table "organizations" */
var OrganizationsConstraint;
(function (OrganizationsConstraint) {
    /** unique or primary key constraint */
    OrganizationsConstraint["organization_pkey"] = "organization_pkey";
    /** unique or primary key constraint */
    OrganizationsConstraint["organizations_slug_key"] = "organizations_slug_key";
})(OrganizationsConstraint = exports.OrganizationsConstraint || (exports.OrganizationsConstraint = {}));
/** select columns of table "organizations" */
var OrganizationsSelectColumn;
(function (OrganizationsSelectColumn) {
    /** column name */
    OrganizationsSelectColumn["avatar"] = "avatar";
    /** column name */
    OrganizationsSelectColumn["city"] = "city";
    /** column name */
    OrganizationsSelectColumn["company_code"] = "company_code";
    /** column name */
    OrganizationsSelectColumn["created_at"] = "created_at";
    /** column name */
    OrganizationsSelectColumn["created_by"] = "created_by";
    /** column name */
    OrganizationsSelectColumn["email"] = "email";
    /** column name */
    OrganizationsSelectColumn["house_number"] = "house_number";
    /** column name */
    OrganizationsSelectColumn["id"] = "id";
    /** column name */
    OrganizationsSelectColumn["name"] = "name";
    /** column name */
    OrganizationsSelectColumn["notes"] = "notes";
    /** column name */
    OrganizationsSelectColumn["phone_number"] = "phone_number";
    /** column name */
    OrganizationsSelectColumn["slug"] = "slug";
    /** column name */
    OrganizationsSelectColumn["street"] = "street";
    /** column name */
    OrganizationsSelectColumn["type"] = "type";
    /** column name */
    OrganizationsSelectColumn["updated_at"] = "updated_at";
    /** column name */
    OrganizationsSelectColumn["vat_number"] = "vat_number";
    /** column name */
    OrganizationsSelectColumn["zip_code"] = "zip_code";
})(OrganizationsSelectColumn = exports.OrganizationsSelectColumn || (exports.OrganizationsSelectColumn = {}));
/** update columns of table "organizations" */
var OrganizationsUpdateColumn;
(function (OrganizationsUpdateColumn) {
    /** column name */
    OrganizationsUpdateColumn["avatar"] = "avatar";
    /** column name */
    OrganizationsUpdateColumn["city"] = "city";
    /** column name */
    OrganizationsUpdateColumn["company_code"] = "company_code";
    /** column name */
    OrganizationsUpdateColumn["created_at"] = "created_at";
    /** column name */
    OrganizationsUpdateColumn["created_by"] = "created_by";
    /** column name */
    OrganizationsUpdateColumn["email"] = "email";
    /** column name */
    OrganizationsUpdateColumn["house_number"] = "house_number";
    /** column name */
    OrganizationsUpdateColumn["id"] = "id";
    /** column name */
    OrganizationsUpdateColumn["name"] = "name";
    /** column name */
    OrganizationsUpdateColumn["notes"] = "notes";
    /** column name */
    OrganizationsUpdateColumn["phone_number"] = "phone_number";
    /** column name */
    OrganizationsUpdateColumn["slug"] = "slug";
    /** column name */
    OrganizationsUpdateColumn["street"] = "street";
    /** column name */
    OrganizationsUpdateColumn["type"] = "type";
    /** column name */
    OrganizationsUpdateColumn["updated_at"] = "updated_at";
    /** column name */
    OrganizationsUpdateColumn["vat_number"] = "vat_number";
    /** column name */
    OrganizationsUpdateColumn["zip_code"] = "zip_code";
})(OrganizationsUpdateColumn = exports.OrganizationsUpdateColumn || (exports.OrganizationsUpdateColumn = {}));
/** select columns of table "permission.folder_permissions" */
var PermissionFolderPermissionsSelectColumn;
(function (PermissionFolderPermissionsSelectColumn) {
    /** column name */
    PermissionFolderPermissionsSelectColumn["expires"] = "expires";
    /** column name */
    PermissionFolderPermissionsSelectColumn["folder_id"] = "folder_id";
    /** column name */
    PermissionFolderPermissionsSelectColumn["folder_scope_id"] = "folder_scope_id";
    /** column name */
    PermissionFolderPermissionsSelectColumn["group_role_id"] = "group_role_id";
    /** column name */
    PermissionFolderPermissionsSelectColumn["member_role_id"] = "member_role_id";
    /** column name */
    PermissionFolderPermissionsSelectColumn["owned_media"] = "owned_media";
    /** column name */
    PermissionFolderPermissionsSelectColumn["role_id"] = "role_id";
    /** column name */
    PermissionFolderPermissionsSelectColumn["shared_media"] = "shared_media";
})(PermissionFolderPermissionsSelectColumn = exports.PermissionFolderPermissionsSelectColumn || (exports.PermissionFolderPermissionsSelectColumn = {}));
/** select columns of table "permission.media_permissions" */
var PermissionMediaPermissionsSelectColumn;
(function (PermissionMediaPermissionsSelectColumn) {
    /** column name */
    PermissionMediaPermissionsSelectColumn["expires"] = "expires";
    /** column name */
    PermissionMediaPermissionsSelectColumn["folder_id"] = "folder_id";
    /** column name */
    PermissionMediaPermissionsSelectColumn["folder_scope_id"] = "folder_scope_id";
    /** column name */
    PermissionMediaPermissionsSelectColumn["group_role_id"] = "group_role_id";
    /** column name */
    PermissionMediaPermissionsSelectColumn["media_asset_id"] = "media_asset_id";
    /** column name */
    PermissionMediaPermissionsSelectColumn["member_role_id"] = "member_role_id";
    /** column name */
    PermissionMediaPermissionsSelectColumn["owned_media"] = "owned_media";
    /** column name */
    PermissionMediaPermissionsSelectColumn["role_id"] = "role_id";
    /** column name */
    PermissionMediaPermissionsSelectColumn["shared_media"] = "shared_media";
})(PermissionMediaPermissionsSelectColumn = exports.PermissionMediaPermissionsSelectColumn || (exports.PermissionMediaPermissionsSelectColumn = {}));
/** select columns of table "permission.meta_permissions" */
var PermissionMetaPermissionsSelectColumn;
(function (PermissionMetaPermissionsSelectColumn) {
    /** column name */
    PermissionMetaPermissionsSelectColumn["expires"] = "expires";
    /** column name */
    PermissionMetaPermissionsSelectColumn["field_id"] = "field_id";
    /** column name */
    PermissionMetaPermissionsSelectColumn["folder_id"] = "folder_id";
    /** column name */
    PermissionMetaPermissionsSelectColumn["folder_scope_id"] = "folder_scope_id";
    /** column name */
    PermissionMetaPermissionsSelectColumn["group_role_id"] = "group_role_id";
    /** column name */
    PermissionMetaPermissionsSelectColumn["media_asset_id"] = "media_asset_id";
    /** column name */
    PermissionMetaPermissionsSelectColumn["member_role_id"] = "member_role_id";
    /** column name */
    PermissionMetaPermissionsSelectColumn["owned_media"] = "owned_media";
    /** column name */
    PermissionMetaPermissionsSelectColumn["role_id"] = "role_id";
    /** column name */
    PermissionMetaPermissionsSelectColumn["scopes"] = "scopes";
    /** column name */
    PermissionMetaPermissionsSelectColumn["shared_media"] = "shared_media";
})(PermissionMetaPermissionsSelectColumn = exports.PermissionMetaPermissionsSelectColumn || (exports.PermissionMetaPermissionsSelectColumn = {}));
/** unique or primary key constraints on table "permission.org_member_roles" */
var PermissionOrgMemberRolesConstraint;
(function (PermissionOrgMemberRolesConstraint) {
    /** unique or primary key constraint */
    PermissionOrgMemberRolesConstraint["org_member_roles_pkey"] = "org_member_roles_pkey";
})(PermissionOrgMemberRolesConstraint = exports.PermissionOrgMemberRolesConstraint || (exports.PermissionOrgMemberRolesConstraint = {}));
/** select columns of table "permission.org_member_roles" */
var PermissionOrgMemberRolesSelectColumn;
(function (PermissionOrgMemberRolesSelectColumn) {
    /** column name */
    PermissionOrgMemberRolesSelectColumn["expires"] = "expires";
    /** column name */
    PermissionOrgMemberRolesSelectColumn["id"] = "id";
    /** column name */
    PermissionOrgMemberRolesSelectColumn["member_id"] = "member_id";
    /** column name */
    PermissionOrgMemberRolesSelectColumn["role_id"] = "role_id";
    /** column name */
    PermissionOrgMemberRolesSelectColumn["user_id"] = "user_id";
})(PermissionOrgMemberRolesSelectColumn = exports.PermissionOrgMemberRolesSelectColumn || (exports.PermissionOrgMemberRolesSelectColumn = {}));
/** update columns of table "permission.org_member_roles" */
var PermissionOrgMemberRolesUpdateColumn;
(function (PermissionOrgMemberRolesUpdateColumn) {
    /** column name */
    PermissionOrgMemberRolesUpdateColumn["expires"] = "expires";
    /** column name */
    PermissionOrgMemberRolesUpdateColumn["id"] = "id";
    /** column name */
    PermissionOrgMemberRolesUpdateColumn["member_id"] = "member_id";
    /** column name */
    PermissionOrgMemberRolesUpdateColumn["role_id"] = "role_id";
    /** column name */
    PermissionOrgMemberRolesUpdateColumn["user_id"] = "user_id";
})(PermissionOrgMemberRolesUpdateColumn = exports.PermissionOrgMemberRolesUpdateColumn || (exports.PermissionOrgMemberRolesUpdateColumn = {}));
/** unique or primary key constraints on table "permission.role_folder_scopes" */
var PermissionRoleFolderScopesConstraint;
(function (PermissionRoleFolderScopesConstraint) {
    /** unique or primary key constraint */
    PermissionRoleFolderScopesConstraint["role_folder_scopes_pkey"] = "role_folder_scopes_pkey";
})(PermissionRoleFolderScopesConstraint = exports.PermissionRoleFolderScopesConstraint || (exports.PermissionRoleFolderScopesConstraint = {}));
/** select columns of table "permission.role_folder_scopes" */
var PermissionRoleFolderScopesSelectColumn;
(function (PermissionRoleFolderScopesSelectColumn) {
    /** column name */
    PermissionRoleFolderScopesSelectColumn["folder_id"] = "folder_id";
    /** column name */
    PermissionRoleFolderScopesSelectColumn["group_role_id"] = "group_role_id";
    /** column name */
    PermissionRoleFolderScopesSelectColumn["id"] = "id";
    /** column name */
    PermissionRoleFolderScopesSelectColumn["member_role_id"] = "member_role_id";
    /** column name */
    PermissionRoleFolderScopesSelectColumn["role_id"] = "role_id";
})(PermissionRoleFolderScopesSelectColumn = exports.PermissionRoleFolderScopesSelectColumn || (exports.PermissionRoleFolderScopesSelectColumn = {}));
/** update columns of table "permission.role_folder_scopes" */
var PermissionRoleFolderScopesUpdateColumn;
(function (PermissionRoleFolderScopesUpdateColumn) {
    /** column name */
    PermissionRoleFolderScopesUpdateColumn["folder_id"] = "folder_id";
    /** column name */
    PermissionRoleFolderScopesUpdateColumn["group_role_id"] = "group_role_id";
    /** column name */
    PermissionRoleFolderScopesUpdateColumn["id"] = "id";
    /** column name */
    PermissionRoleFolderScopesUpdateColumn["member_role_id"] = "member_role_id";
    /** column name */
    PermissionRoleFolderScopesUpdateColumn["role_id"] = "role_id";
})(PermissionRoleFolderScopesUpdateColumn = exports.PermissionRoleFolderScopesUpdateColumn || (exports.PermissionRoleFolderScopesUpdateColumn = {}));
/** unique or primary key constraints on table "permission.role_meta_scopes" */
var PermissionRoleMetaScopesConstraint;
(function (PermissionRoleMetaScopesConstraint) {
    /** unique or primary key constraint */
    PermissionRoleMetaScopesConstraint["role_meta_scopes_pkey"] = "role_meta_scopes_pkey";
})(PermissionRoleMetaScopesConstraint = exports.PermissionRoleMetaScopesConstraint || (exports.PermissionRoleMetaScopesConstraint = {}));
/** select columns of table "permission.role_meta_scopes" */
var PermissionRoleMetaScopesSelectColumn;
(function (PermissionRoleMetaScopesSelectColumn) {
    /** column name */
    PermissionRoleMetaScopesSelectColumn["field_id"] = "field_id";
    /** column name */
    PermissionRoleMetaScopesSelectColumn["role_id"] = "role_id";
    /** column name */
    PermissionRoleMetaScopesSelectColumn["scopes"] = "scopes";
})(PermissionRoleMetaScopesSelectColumn = exports.PermissionRoleMetaScopesSelectColumn || (exports.PermissionRoleMetaScopesSelectColumn = {}));
/** update columns of table "permission.role_meta_scopes" */
var PermissionRoleMetaScopesUpdateColumn;
(function (PermissionRoleMetaScopesUpdateColumn) {
    /** column name */
    PermissionRoleMetaScopesUpdateColumn["field_id"] = "field_id";
    /** column name */
    PermissionRoleMetaScopesUpdateColumn["role_id"] = "role_id";
    /** column name */
    PermissionRoleMetaScopesUpdateColumn["scopes"] = "scopes";
})(PermissionRoleMetaScopesUpdateColumn = exports.PermissionRoleMetaScopesUpdateColumn || (exports.PermissionRoleMetaScopesUpdateColumn = {}));
/** unique or primary key constraints on table "permission.roles" */
var PermissionRolesConstraint;
(function (PermissionRolesConstraint) {
    /** unique or primary key constraint */
    PermissionRolesConstraint["roles_pkey"] = "roles_pkey";
})(PermissionRolesConstraint = exports.PermissionRolesConstraint || (exports.PermissionRolesConstraint = {}));
/** select columns of table "permission.roles" */
var PermissionRolesSelectColumn;
(function (PermissionRolesSelectColumn) {
    /** column name */
    PermissionRolesSelectColumn["id"] = "id";
    /** column name */
    PermissionRolesSelectColumn["name"] = "name";
    /** column name */
    PermissionRolesSelectColumn["notes"] = "notes";
    /** column name */
    PermissionRolesSelectColumn["org_data"] = "org_data";
    /** column name */
    PermissionRolesSelectColumn["org_id"] = "org_id";
    /** column name */
    PermissionRolesSelectColumn["org_members"] = "org_members";
    /** column name */
    PermissionRolesSelectColumn["owned_media"] = "owned_media";
    /** column name */
    PermissionRolesSelectColumn["scope_enum"] = "scope_enum";
    /** column name */
    PermissionRolesSelectColumn["shared_media"] = "shared_media";
    /** column name */
    PermissionRolesSelectColumn["type"] = "type";
})(PermissionRolesSelectColumn = exports.PermissionRolesSelectColumn || (exports.PermissionRolesSelectColumn = {}));
/** update columns of table "permission.roles" */
var PermissionRolesUpdateColumn;
(function (PermissionRolesUpdateColumn) {
    /** column name */
    PermissionRolesUpdateColumn["id"] = "id";
    /** column name */
    PermissionRolesUpdateColumn["name"] = "name";
    /** column name */
    PermissionRolesUpdateColumn["notes"] = "notes";
    /** column name */
    PermissionRolesUpdateColumn["org_data"] = "org_data";
    /** column name */
    PermissionRolesUpdateColumn["org_id"] = "org_id";
    /** column name */
    PermissionRolesUpdateColumn["org_members"] = "org_members";
    /** column name */
    PermissionRolesUpdateColumn["owned_media"] = "owned_media";
    /** column name */
    PermissionRolesUpdateColumn["scope_enum"] = "scope_enum";
    /** column name */
    PermissionRolesUpdateColumn["shared_media"] = "shared_media";
    /** column name */
    PermissionRolesUpdateColumn["type"] = "type";
})(PermissionRolesUpdateColumn = exports.PermissionRolesUpdateColumn || (exports.PermissionRolesUpdateColumn = {}));
/** unique or primary key constraints on table "permission.scopes" */
var PermissionScopesConstraint;
(function (PermissionScopesConstraint) {
    /** unique or primary key constraint */
    PermissionScopesConstraint["scopes_pkey"] = "scopes_pkey";
})(PermissionScopesConstraint = exports.PermissionScopesConstraint || (exports.PermissionScopesConstraint = {}));
var PermissionScopesEnum;
(function (PermissionScopesEnum) {
    PermissionScopesEnum["DELETE"] = "DELETE";
    PermissionScopesEnum["EDIT"] = "EDIT";
    PermissionScopesEnum["VIEW"] = "VIEW";
})(PermissionScopesEnum = exports.PermissionScopesEnum || (exports.PermissionScopesEnum = {}));
/** select columns of table "permission.scopes" */
var PermissionScopesSelectColumn;
(function (PermissionScopesSelectColumn) {
    /** column name */
    PermissionScopesSelectColumn["scope"] = "scope";
})(PermissionScopesSelectColumn = exports.PermissionScopesSelectColumn || (exports.PermissionScopesSelectColumn = {}));
/** update columns of table "permission.scopes" */
var PermissionScopesUpdateColumn;
(function (PermissionScopesUpdateColumn) {
    /** column name */
    PermissionScopesUpdateColumn["scope"] = "scope";
})(PermissionScopesUpdateColumn = exports.PermissionScopesUpdateColumn || (exports.PermissionScopesUpdateColumn = {}));
/** unique or primary key constraints on table "permission.user_group_members" */
var PermissionUserGroupMembersConstraint;
(function (PermissionUserGroupMembersConstraint) {
    /** unique or primary key constraint */
    PermissionUserGroupMembersConstraint["user_group_members_group_id_member_id_key"] = "user_group_members_group_id_member_id_key";
    /** unique or primary key constraint */
    PermissionUserGroupMembersConstraint["user_group_members_pkey"] = "user_group_members_pkey";
})(PermissionUserGroupMembersConstraint = exports.PermissionUserGroupMembersConstraint || (exports.PermissionUserGroupMembersConstraint = {}));
/** select columns of table "permission.user_group_members" */
var PermissionUserGroupMembersSelectColumn;
(function (PermissionUserGroupMembersSelectColumn) {
    /** column name */
    PermissionUserGroupMembersSelectColumn["group_id"] = "group_id";
    /** column name */
    PermissionUserGroupMembersSelectColumn["id"] = "id";
    /** column name */
    PermissionUserGroupMembersSelectColumn["member_id"] = "member_id";
    /** column name */
    PermissionUserGroupMembersSelectColumn["user_id"] = "user_id";
})(PermissionUserGroupMembersSelectColumn = exports.PermissionUserGroupMembersSelectColumn || (exports.PermissionUserGroupMembersSelectColumn = {}));
/** update columns of table "permission.user_group_members" */
var PermissionUserGroupMembersUpdateColumn;
(function (PermissionUserGroupMembersUpdateColumn) {
    /** column name */
    PermissionUserGroupMembersUpdateColumn["group_id"] = "group_id";
    /** column name */
    PermissionUserGroupMembersUpdateColumn["id"] = "id";
    /** column name */
    PermissionUserGroupMembersUpdateColumn["member_id"] = "member_id";
    /** column name */
    PermissionUserGroupMembersUpdateColumn["user_id"] = "user_id";
})(PermissionUserGroupMembersUpdateColumn = exports.PermissionUserGroupMembersUpdateColumn || (exports.PermissionUserGroupMembersUpdateColumn = {}));
/** unique or primary key constraints on table "permission.user_group_roles" */
var PermissionUserGroupRolesConstraint;
(function (PermissionUserGroupRolesConstraint) {
    /** unique or primary key constraint */
    PermissionUserGroupRolesConstraint["user_group_roles_pkey"] = "user_group_roles_pkey";
})(PermissionUserGroupRolesConstraint = exports.PermissionUserGroupRolesConstraint || (exports.PermissionUserGroupRolesConstraint = {}));
/** select columns of table "permission.user_group_roles" */
var PermissionUserGroupRolesSelectColumn;
(function (PermissionUserGroupRolesSelectColumn) {
    /** column name */
    PermissionUserGroupRolesSelectColumn["expires"] = "expires";
    /** column name */
    PermissionUserGroupRolesSelectColumn["group_id"] = "group_id";
    /** column name */
    PermissionUserGroupRolesSelectColumn["id"] = "id";
    /** column name */
    PermissionUserGroupRolesSelectColumn["role_id"] = "role_id";
})(PermissionUserGroupRolesSelectColumn = exports.PermissionUserGroupRolesSelectColumn || (exports.PermissionUserGroupRolesSelectColumn = {}));
/** update columns of table "permission.user_group_roles" */
var PermissionUserGroupRolesUpdateColumn;
(function (PermissionUserGroupRolesUpdateColumn) {
    /** column name */
    PermissionUserGroupRolesUpdateColumn["expires"] = "expires";
    /** column name */
    PermissionUserGroupRolesUpdateColumn["group_id"] = "group_id";
    /** column name */
    PermissionUserGroupRolesUpdateColumn["id"] = "id";
    /** column name */
    PermissionUserGroupRolesUpdateColumn["role_id"] = "role_id";
})(PermissionUserGroupRolesUpdateColumn = exports.PermissionUserGroupRolesUpdateColumn || (exports.PermissionUserGroupRolesUpdateColumn = {}));
/** select columns of table "permission.user_group_users" */
var PermissionUserGroupUsersSelectColumn;
(function (PermissionUserGroupUsersSelectColumn) {
    /** column name */
    PermissionUserGroupUsersSelectColumn["expires"] = "expires";
    /** column name */
    PermissionUserGroupUsersSelectColumn["group_role_id"] = "group_role_id";
    /** column name */
    PermissionUserGroupUsersSelectColumn["role_id"] = "role_id";
    /** column name */
    PermissionUserGroupUsersSelectColumn["user_group_id"] = "user_group_id";
    /** column name */
    PermissionUserGroupUsersSelectColumn["user_id"] = "user_id";
})(PermissionUserGroupUsersSelectColumn = exports.PermissionUserGroupUsersSelectColumn || (exports.PermissionUserGroupUsersSelectColumn = {}));
/** unique or primary key constraints on table "permission.user_groups" */
var PermissionUserGroupsConstraint;
(function (PermissionUserGroupsConstraint) {
    /** unique or primary key constraint */
    PermissionUserGroupsConstraint["user_groups_pkey"] = "user_groups_pkey";
})(PermissionUserGroupsConstraint = exports.PermissionUserGroupsConstraint || (exports.PermissionUserGroupsConstraint = {}));
/** select columns of table "permission.user_groups" */
var PermissionUserGroupsSelectColumn;
(function (PermissionUserGroupsSelectColumn) {
    /** column name */
    PermissionUserGroupsSelectColumn["created_at"] = "created_at";
    /** column name */
    PermissionUserGroupsSelectColumn["id"] = "id";
    /** column name */
    PermissionUserGroupsSelectColumn["name"] = "name";
    /** column name */
    PermissionUserGroupsSelectColumn["org_id"] = "org_id";
    /** column name */
    PermissionUserGroupsSelectColumn["updated_at"] = "updated_at";
})(PermissionUserGroupsSelectColumn = exports.PermissionUserGroupsSelectColumn || (exports.PermissionUserGroupsSelectColumn = {}));
/** update columns of table "permission.user_groups" */
var PermissionUserGroupsUpdateColumn;
(function (PermissionUserGroupsUpdateColumn) {
    /** column name */
    PermissionUserGroupsUpdateColumn["created_at"] = "created_at";
    /** column name */
    PermissionUserGroupsUpdateColumn["id"] = "id";
    /** column name */
    PermissionUserGroupsUpdateColumn["name"] = "name";
    /** column name */
    PermissionUserGroupsUpdateColumn["org_id"] = "org_id";
    /** column name */
    PermissionUserGroupsUpdateColumn["updated_at"] = "updated_at";
})(PermissionUserGroupsUpdateColumn = exports.PermissionUserGroupsUpdateColumn || (exports.PermissionUserGroupsUpdateColumn = {}));
/** unique or primary key constraints on table "projects" */
var ProjectsConstraint;
(function (ProjectsConstraint) {
    /** unique or primary key constraint */
    ProjectsConstraint["project_pkey"] = "project_pkey";
    /** unique or primary key constraint */
    ProjectsConstraint["projects_slug_org_id_key"] = "projects_slug_org_id_key";
})(ProjectsConstraint = exports.ProjectsConstraint || (exports.ProjectsConstraint = {}));
/** select columns of table "projects" */
var ProjectsSelectColumn;
(function (ProjectsSelectColumn) {
    /** column name */
    ProjectsSelectColumn["created_at"] = "created_at";
    /** column name */
    ProjectsSelectColumn["created_by"] = "created_by";
    /** column name */
    ProjectsSelectColumn["default_locale"] = "default_locale";
    /** column name */
    ProjectsSelectColumn["id"] = "id";
    /** column name */
    ProjectsSelectColumn["image_url"] = "image_url";
    /** column name */
    ProjectsSelectColumn["locales"] = "locales";
    /** column name */
    ProjectsSelectColumn["name"] = "name";
    /** column name */
    ProjectsSelectColumn["org_id"] = "org_id";
    /** column name */
    ProjectsSelectColumn["publishing_url"] = "publishing_url";
    /** column name */
    ProjectsSelectColumn["slug"] = "slug";
    /** column name */
    ProjectsSelectColumn["updated_at"] = "updated_at";
})(ProjectsSelectColumn = exports.ProjectsSelectColumn || (exports.ProjectsSelectColumn = {}));
/** update columns of table "projects" */
var ProjectsUpdateColumn;
(function (ProjectsUpdateColumn) {
    /** column name */
    ProjectsUpdateColumn["created_at"] = "created_at";
    /** column name */
    ProjectsUpdateColumn["created_by"] = "created_by";
    /** column name */
    ProjectsUpdateColumn["default_locale"] = "default_locale";
    /** column name */
    ProjectsUpdateColumn["id"] = "id";
    /** column name */
    ProjectsUpdateColumn["image_url"] = "image_url";
    /** column name */
    ProjectsUpdateColumn["locales"] = "locales";
    /** column name */
    ProjectsUpdateColumn["name"] = "name";
    /** column name */
    ProjectsUpdateColumn["org_id"] = "org_id";
    /** column name */
    ProjectsUpdateColumn["publishing_url"] = "publishing_url";
    /** column name */
    ProjectsUpdateColumn["slug"] = "slug";
    /** column name */
    ProjectsUpdateColumn["updated_at"] = "updated_at";
})(ProjectsUpdateColumn = exports.ProjectsUpdateColumn || (exports.ProjectsUpdateColumn = {}));
/** unique or primary key constraints on table "s3_data_warehouses" */
var S3DataWarehousesConstraint;
(function (S3DataWarehousesConstraint) {
    /** unique or primary key constraint */
    S3DataWarehousesConstraint["s3_data_warehouses_pkey"] = "s3_data_warehouses_pkey";
})(S3DataWarehousesConstraint = exports.S3DataWarehousesConstraint || (exports.S3DataWarehousesConstraint = {}));
/** select columns of table "s3_data_warehouses" */
var S3DataWarehousesSelectColumn;
(function (S3DataWarehousesSelectColumn) {
    /** column name */
    S3DataWarehousesSelectColumn["access_key"] = "access_key";
    /** column name */
    S3DataWarehousesSelectColumn["access_secret"] = "access_secret";
    /** column name */
    S3DataWarehousesSelectColumn["bucket"] = "bucket";
    /** column name */
    S3DataWarehousesSelectColumn["created_at"] = "created_at";
    /** column name */
    S3DataWarehousesSelectColumn["endpoint"] = "endpoint";
    /** column name */
    S3DataWarehousesSelectColumn["id"] = "id";
    /** column name */
    S3DataWarehousesSelectColumn["name"] = "name";
    /** column name */
    S3DataWarehousesSelectColumn["region"] = "region";
    /** column name */
    S3DataWarehousesSelectColumn["updated_at"] = "updated_at";
})(S3DataWarehousesSelectColumn = exports.S3DataWarehousesSelectColumn || (exports.S3DataWarehousesSelectColumn = {}));
/** update columns of table "s3_data_warehouses" */
var S3DataWarehousesUpdateColumn;
(function (S3DataWarehousesUpdateColumn) {
    /** column name */
    S3DataWarehousesUpdateColumn["access_key"] = "access_key";
    /** column name */
    S3DataWarehousesUpdateColumn["access_secret"] = "access_secret";
    /** column name */
    S3DataWarehousesUpdateColumn["bucket"] = "bucket";
    /** column name */
    S3DataWarehousesUpdateColumn["created_at"] = "created_at";
    /** column name */
    S3DataWarehousesUpdateColumn["endpoint"] = "endpoint";
    /** column name */
    S3DataWarehousesUpdateColumn["id"] = "id";
    /** column name */
    S3DataWarehousesUpdateColumn["name"] = "name";
    /** column name */
    S3DataWarehousesUpdateColumn["region"] = "region";
    /** column name */
    S3DataWarehousesUpdateColumn["updated_at"] = "updated_at";
})(S3DataWarehousesUpdateColumn = exports.S3DataWarehousesUpdateColumn || (exports.S3DataWarehousesUpdateColumn = {}));
/** unique or primary key constraints on table "thumbnail_profiles" */
var ThumbnailProfilesConstraint;
(function (ThumbnailProfilesConstraint) {
    /** unique or primary key constraint */
    ThumbnailProfilesConstraint["thumbnail_profiles_output_file_id_key"] = "thumbnail_profiles_output_file_id_key";
    /** unique or primary key constraint */
    ThumbnailProfilesConstraint["thumbnail_profiles_pkey"] = "thumbnail_profiles_pkey";
})(ThumbnailProfilesConstraint = exports.ThumbnailProfilesConstraint || (exports.ThumbnailProfilesConstraint = {}));
/** select columns of table "thumbnail_profiles" */
var ThumbnailProfilesSelectColumn;
(function (ThumbnailProfilesSelectColumn) {
    /** column name */
    ThumbnailProfilesSelectColumn["created_at"] = "created_at";
    /** column name */
    ThumbnailProfilesSelectColumn["height"] = "height";
    /** column name */
    ThumbnailProfilesSelectColumn["id"] = "id";
    /** column name */
    ThumbnailProfilesSelectColumn["original_file_id"] = "original_file_id";
    /** column name */
    ThumbnailProfilesSelectColumn["output_file_id"] = "output_file_id";
    /** column name */
    ThumbnailProfilesSelectColumn["seconds"] = "seconds";
    /** column name */
    ThumbnailProfilesSelectColumn["status"] = "status";
    /** column name */
    ThumbnailProfilesSelectColumn["updated_at"] = "updated_at";
    /** column name */
    ThumbnailProfilesSelectColumn["width"] = "width";
})(ThumbnailProfilesSelectColumn = exports.ThumbnailProfilesSelectColumn || (exports.ThumbnailProfilesSelectColumn = {}));
/** update columns of table "thumbnail_profiles" */
var ThumbnailProfilesUpdateColumn;
(function (ThumbnailProfilesUpdateColumn) {
    /** column name */
    ThumbnailProfilesUpdateColumn["created_at"] = "created_at";
    /** column name */
    ThumbnailProfilesUpdateColumn["height"] = "height";
    /** column name */
    ThumbnailProfilesUpdateColumn["id"] = "id";
    /** column name */
    ThumbnailProfilesUpdateColumn["original_file_id"] = "original_file_id";
    /** column name */
    ThumbnailProfilesUpdateColumn["output_file_id"] = "output_file_id";
    /** column name */
    ThumbnailProfilesUpdateColumn["seconds"] = "seconds";
    /** column name */
    ThumbnailProfilesUpdateColumn["status"] = "status";
    /** column name */
    ThumbnailProfilesUpdateColumn["updated_at"] = "updated_at";
    /** column name */
    ThumbnailProfilesUpdateColumn["width"] = "width";
})(ThumbnailProfilesUpdateColumn = exports.ThumbnailProfilesUpdateColumn || (exports.ThumbnailProfilesUpdateColumn = {}));
/** unique or primary key constraints on table "ticketing.access_codes" */
var TicketingAccessCodesConstraint;
(function (TicketingAccessCodesConstraint) {
    /** unique or primary key constraint */
    TicketingAccessCodesConstraint["access_codes_content_row_id_key"] = "access_codes_content_row_id_key";
    /** unique or primary key constraint */
    TicketingAccessCodesConstraint["access_codes_pkey"] = "access_codes_pkey";
})(TicketingAccessCodesConstraint = exports.TicketingAccessCodesConstraint || (exports.TicketingAccessCodesConstraint = {}));
/** select columns of table "ticketing.access_codes" */
var TicketingAccessCodesSelectColumn;
(function (TicketingAccessCodesSelectColumn) {
    /** column name */
    TicketingAccessCodesSelectColumn["code"] = "code";
    /** column name */
    TicketingAccessCodesSelectColumn["codes"] = "codes";
    /** column name */
    TicketingAccessCodesSelectColumn["content_row_id"] = "content_row_id";
    /** column name */
    TicketingAccessCodesSelectColumn["created_at"] = "created_at";
    /** column name */
    TicketingAccessCodesSelectColumn["id"] = "id";
})(TicketingAccessCodesSelectColumn = exports.TicketingAccessCodesSelectColumn || (exports.TicketingAccessCodesSelectColumn = {}));
/** update columns of table "ticketing.access_codes" */
var TicketingAccessCodesUpdateColumn;
(function (TicketingAccessCodesUpdateColumn) {
    /** column name */
    TicketingAccessCodesUpdateColumn["code"] = "code";
    /** column name */
    TicketingAccessCodesUpdateColumn["codes"] = "codes";
    /** column name */
    TicketingAccessCodesUpdateColumn["content_row_id"] = "content_row_id";
    /** column name */
    TicketingAccessCodesUpdateColumn["created_at"] = "created_at";
    /** column name */
    TicketingAccessCodesUpdateColumn["id"] = "id";
})(TicketingAccessCodesUpdateColumn = exports.TicketingAccessCodesUpdateColumn || (exports.TicketingAccessCodesUpdateColumn = {}));
/** unique or primary key constraints on table "ticketing.access_tokens" */
var TicketingAccessTokensConstraint;
(function (TicketingAccessTokensConstraint) {
    /** unique or primary key constraint */
    TicketingAccessTokensConstraint["access_tokens_access_code_id_key"] = "access_tokens_access_code_id_key";
    /** unique or primary key constraint */
    TicketingAccessTokensConstraint["access_tokens_pkey"] = "access_tokens_pkey";
})(TicketingAccessTokensConstraint = exports.TicketingAccessTokensConstraint || (exports.TicketingAccessTokensConstraint = {}));
/** select columns of table "ticketing.access_tokens" */
var TicketingAccessTokensSelectColumn;
(function (TicketingAccessTokensSelectColumn) {
    /** column name */
    TicketingAccessTokensSelectColumn["access_code_id"] = "access_code_id";
    /** column name */
    TicketingAccessTokensSelectColumn["code"] = "code";
    /** column name */
    TicketingAccessTokensSelectColumn["content_row_id"] = "content_row_id";
    /** column name */
    TicketingAccessTokensSelectColumn["created_at"] = "created_at";
    /** column name */
    TicketingAccessTokensSelectColumn["extra_data"] = "extra_data";
    /** column name */
    TicketingAccessTokensSelectColumn["id"] = "id";
    /** column name */
    TicketingAccessTokensSelectColumn["ip"] = "ip";
})(TicketingAccessTokensSelectColumn = exports.TicketingAccessTokensSelectColumn || (exports.TicketingAccessTokensSelectColumn = {}));
/** update columns of table "ticketing.access_tokens" */
var TicketingAccessTokensUpdateColumn;
(function (TicketingAccessTokensUpdateColumn) {
    /** column name */
    TicketingAccessTokensUpdateColumn["access_code_id"] = "access_code_id";
    /** column name */
    TicketingAccessTokensUpdateColumn["code"] = "code";
    /** column name */
    TicketingAccessTokensUpdateColumn["content_row_id"] = "content_row_id";
    /** column name */
    TicketingAccessTokensUpdateColumn["created_at"] = "created_at";
    /** column name */
    TicketingAccessTokensUpdateColumn["extra_data"] = "extra_data";
    /** column name */
    TicketingAccessTokensUpdateColumn["id"] = "id";
    /** column name */
    TicketingAccessTokensUpdateColumn["ip"] = "ip";
})(TicketingAccessTokensUpdateColumn = exports.TicketingAccessTokensUpdateColumn || (exports.TicketingAccessTokensUpdateColumn = {}));
/** unique or primary key constraints on table "ticketing.ticket_options" */
var TicketingTicketOptionsConstraint;
(function (TicketingTicketOptionsConstraint) {
    /** unique or primary key constraint */
    TicketingTicketOptionsConstraint["ticket_options_pkey"] = "ticket_options_pkey";
})(TicketingTicketOptionsConstraint = exports.TicketingTicketOptionsConstraint || (exports.TicketingTicketOptionsConstraint = {}));
/** select columns of table "ticketing.ticket_options" */
var TicketingTicketOptionsSelectColumn;
(function (TicketingTicketOptionsSelectColumn) {
    /** column name */
    TicketingTicketOptionsSelectColumn["content_id"] = "content_id";
    /** column name */
    TicketingTicketOptionsSelectColumn["created_at"] = "created_at";
    /** column name */
    TicketingTicketOptionsSelectColumn["currency"] = "currency";
    /** column name */
    TicketingTicketOptionsSelectColumn["id"] = "id";
    /** column name */
    TicketingTicketOptionsSelectColumn["name"] = "name";
    /** column name */
    TicketingTicketOptionsSelectColumn["price"] = "price";
    /** column name */
    TicketingTicketOptionsSelectColumn["ticket_type"] = "ticket_type";
    /** column name */
    TicketingTicketOptionsSelectColumn["valid_for_amount"] = "valid_for_amount";
    /** column name */
    TicketingTicketOptionsSelectColumn["valid_for_unit"] = "valid_for_unit";
    /** column name */
    TicketingTicketOptionsSelectColumn["valid_until"] = "valid_until";
})(TicketingTicketOptionsSelectColumn = exports.TicketingTicketOptionsSelectColumn || (exports.TicketingTicketOptionsSelectColumn = {}));
/** update columns of table "ticketing.ticket_options" */
var TicketingTicketOptionsUpdateColumn;
(function (TicketingTicketOptionsUpdateColumn) {
    /** column name */
    TicketingTicketOptionsUpdateColumn["content_id"] = "content_id";
    /** column name */
    TicketingTicketOptionsUpdateColumn["created_at"] = "created_at";
    /** column name */
    TicketingTicketOptionsUpdateColumn["currency"] = "currency";
    /** column name */
    TicketingTicketOptionsUpdateColumn["id"] = "id";
    /** column name */
    TicketingTicketOptionsUpdateColumn["name"] = "name";
    /** column name */
    TicketingTicketOptionsUpdateColumn["price"] = "price";
    /** column name */
    TicketingTicketOptionsUpdateColumn["ticket_type"] = "ticket_type";
    /** column name */
    TicketingTicketOptionsUpdateColumn["valid_for_amount"] = "valid_for_amount";
    /** column name */
    TicketingTicketOptionsUpdateColumn["valid_for_unit"] = "valid_for_unit";
    /** column name */
    TicketingTicketOptionsUpdateColumn["valid_until"] = "valid_until";
})(TicketingTicketOptionsUpdateColumn = exports.TicketingTicketOptionsUpdateColumn || (exports.TicketingTicketOptionsUpdateColumn = {}));
/** unique or primary key constraints on table "ticketing.visitor_tickets" */
var TicketingVisitorTicketsConstraint;
(function (TicketingVisitorTicketsConstraint) {
    /** unique or primary key constraint */
    TicketingVisitorTicketsConstraint["visitor_tickets_pkey"] = "visitor_tickets_pkey";
})(TicketingVisitorTicketsConstraint = exports.TicketingVisitorTicketsConstraint || (exports.TicketingVisitorTicketsConstraint = {}));
/** select columns of table "ticketing.visitor_tickets" */
var TicketingVisitorTicketsSelectColumn;
(function (TicketingVisitorTicketsSelectColumn) {
    /** column name */
    TicketingVisitorTicketsSelectColumn["content_row_id"] = "content_row_id";
    /** column name */
    TicketingVisitorTicketsSelectColumn["created_at"] = "created_at";
    /** column name */
    TicketingVisitorTicketsSelectColumn["extra_data"] = "extra_data";
    /** column name */
    TicketingVisitorTicketsSelectColumn["id"] = "id";
    /** column name */
    TicketingVisitorTicketsSelectColumn["tiecket_option_id"] = "tiecket_option_id";
    /** column name */
    TicketingVisitorTicketsSelectColumn["updated_at"] = "updated_at";
    /** column name */
    TicketingVisitorTicketsSelectColumn["valid_until"] = "valid_until";
    /** column name */
    TicketingVisitorTicketsSelectColumn["visitor_id"] = "visitor_id";
})(TicketingVisitorTicketsSelectColumn = exports.TicketingVisitorTicketsSelectColumn || (exports.TicketingVisitorTicketsSelectColumn = {}));
/** update columns of table "ticketing.visitor_tickets" */
var TicketingVisitorTicketsUpdateColumn;
(function (TicketingVisitorTicketsUpdateColumn) {
    /** column name */
    TicketingVisitorTicketsUpdateColumn["content_row_id"] = "content_row_id";
    /** column name */
    TicketingVisitorTicketsUpdateColumn["created_at"] = "created_at";
    /** column name */
    TicketingVisitorTicketsUpdateColumn["extra_data"] = "extra_data";
    /** column name */
    TicketingVisitorTicketsUpdateColumn["id"] = "id";
    /** column name */
    TicketingVisitorTicketsUpdateColumn["tiecket_option_id"] = "tiecket_option_id";
    /** column name */
    TicketingVisitorTicketsUpdateColumn["updated_at"] = "updated_at";
    /** column name */
    TicketingVisitorTicketsUpdateColumn["valid_until"] = "valid_until";
    /** column name */
    TicketingVisitorTicketsUpdateColumn["visitor_id"] = "visitor_id";
})(TicketingVisitorTicketsUpdateColumn = exports.TicketingVisitorTicketsUpdateColumn || (exports.TicketingVisitorTicketsUpdateColumn = {}));
/** unique or primary key constraints on table "transcoder_job_status_types" */
var TranscoderJobStatusTypesConstraint;
(function (TranscoderJobStatusTypesConstraint) {
    /** unique or primary key constraint */
    TranscoderJobStatusTypesConstraint["transcoder_job_status_types_pkey"] = "transcoder_job_status_types_pkey";
})(TranscoderJobStatusTypesConstraint = exports.TranscoderJobStatusTypesConstraint || (exports.TranscoderJobStatusTypesConstraint = {}));
var TranscoderJobStatusTypesEnum;
(function (TranscoderJobStatusTypesEnum) {
    TranscoderJobStatusTypesEnum["FAILED"] = "FAILED";
    TranscoderJobStatusTypesEnum["FINISHED"] = "FINISHED";
    TranscoderJobStatusTypesEnum["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TranscoderJobStatusTypesEnum["PROCESSING"] = "PROCESSING";
    TranscoderJobStatusTypesEnum["WAITING_FOR_PROCESSING"] = "WAITING_FOR_PROCESSING";
})(TranscoderJobStatusTypesEnum = exports.TranscoderJobStatusTypesEnum || (exports.TranscoderJobStatusTypesEnum = {}));
/** select columns of table "transcoder_job_status_types" */
var TranscoderJobStatusTypesSelectColumn;
(function (TranscoderJobStatusTypesSelectColumn) {
    /** column name */
    TranscoderJobStatusTypesSelectColumn["type"] = "type";
})(TranscoderJobStatusTypesSelectColumn = exports.TranscoderJobStatusTypesSelectColumn || (exports.TranscoderJobStatusTypesSelectColumn = {}));
/** update columns of table "transcoder_job_status_types" */
var TranscoderJobStatusTypesUpdateColumn;
(function (TranscoderJobStatusTypesUpdateColumn) {
    /** column name */
    TranscoderJobStatusTypesUpdateColumn["type"] = "type";
})(TranscoderJobStatusTypesUpdateColumn = exports.TranscoderJobStatusTypesUpdateColumn || (exports.TranscoderJobStatusTypesUpdateColumn = {}));
/** unique or primary key constraints on table "transcoder_jobs" */
var TranscoderJobsConstraint;
(function (TranscoderJobsConstraint) {
    /** unique or primary key constraint */
    TranscoderJobsConstraint["transcoder_jobs_pkey"] = "transcoder_jobs_pkey";
})(TranscoderJobsConstraint = exports.TranscoderJobsConstraint || (exports.TranscoderJobsConstraint = {}));
/** select columns of table "transcoder_jobs" */
var TranscoderJobsSelectColumn;
(function (TranscoderJobsSelectColumn) {
    /** column name */
    TranscoderJobsSelectColumn["created_at"] = "created_at";
    /** column name */
    TranscoderJobsSelectColumn["id"] = "id";
    /** column name */
    TranscoderJobsSelectColumn["is_dry_run"] = "is_dry_run";
    /** column name */
    TranscoderJobsSelectColumn["org_id"] = "org_id";
    /** column name */
    TranscoderJobsSelectColumn["status"] = "status";
    /** column name */
    TranscoderJobsSelectColumn["thumbnail_height"] = "thumbnail_height";
    /** column name */
    TranscoderJobsSelectColumn["thumbnail_seconds"] = "thumbnail_seconds";
    /** column name */
    TranscoderJobsSelectColumn["transcoder_profile_id"] = "transcoder_profile_id";
    /** column name */
    TranscoderJobsSelectColumn["updated_at"] = "updated_at";
})(TranscoderJobsSelectColumn = exports.TranscoderJobsSelectColumn || (exports.TranscoderJobsSelectColumn = {}));
/** update columns of table "transcoder_jobs" */
var TranscoderJobsUpdateColumn;
(function (TranscoderJobsUpdateColumn) {
    /** column name */
    TranscoderJobsUpdateColumn["created_at"] = "created_at";
    /** column name */
    TranscoderJobsUpdateColumn["id"] = "id";
    /** column name */
    TranscoderJobsUpdateColumn["is_dry_run"] = "is_dry_run";
    /** column name */
    TranscoderJobsUpdateColumn["org_id"] = "org_id";
    /** column name */
    TranscoderJobsUpdateColumn["status"] = "status";
    /** column name */
    TranscoderJobsUpdateColumn["thumbnail_height"] = "thumbnail_height";
    /** column name */
    TranscoderJobsUpdateColumn["thumbnail_seconds"] = "thumbnail_seconds";
    /** column name */
    TranscoderJobsUpdateColumn["transcoder_profile_id"] = "transcoder_profile_id";
    /** column name */
    TranscoderJobsUpdateColumn["updated_at"] = "updated_at";
})(TranscoderJobsUpdateColumn = exports.TranscoderJobsUpdateColumn || (exports.TranscoderJobsUpdateColumn = {}));
/** unique or primary key constraints on table "transcoder_profiles" */
var TranscoderProfilesConstraint;
(function (TranscoderProfilesConstraint) {
    /** unique or primary key constraint */
    TranscoderProfilesConstraint["transcoder_profiles_output_file_id_key"] = "transcoder_profiles_output_file_id_key";
    /** unique or primary key constraint */
    TranscoderProfilesConstraint["transcoder_profiles_pkey"] = "transcoder_profiles_pkey";
})(TranscoderProfilesConstraint = exports.TranscoderProfilesConstraint || (exports.TranscoderProfilesConstraint = {}));
/** select columns of table "transcoder_profiles" */
var TranscoderProfilesSelectColumn;
(function (TranscoderProfilesSelectColumn) {
    /** column name */
    TranscoderProfilesSelectColumn["audio_bitrate_kbps"] = "audio_bitrate_kbps";
    /** column name */
    TranscoderProfilesSelectColumn["created_at"] = "created_at";
    /** column name */
    TranscoderProfilesSelectColumn["frame_rate"] = "frame_rate";
    /** column name */
    TranscoderProfilesSelectColumn["height"] = "height";
    /** column name */
    TranscoderProfilesSelectColumn["id"] = "id";
    /** column name */
    TranscoderProfilesSelectColumn["includes_audio"] = "includes_audio";
    /** column name */
    TranscoderProfilesSelectColumn["includes_video"] = "includes_video";
    /** column name */
    TranscoderProfilesSelectColumn["name"] = "name";
    /** column name */
    TranscoderProfilesSelectColumn["org_id"] = "org_id";
    /** column name */
    TranscoderProfilesSelectColumn["original_file_id"] = "original_file_id";
    /** column name */
    TranscoderProfilesSelectColumn["output_file_id"] = "output_file_id";
    /** column name */
    TranscoderProfilesSelectColumn["status"] = "status";
    /** column name */
    TranscoderProfilesSelectColumn["updated_at"] = "updated_at";
    /** column name */
    TranscoderProfilesSelectColumn["video_bitrate_kbps"] = "video_bitrate_kbps";
    /** column name */
    TranscoderProfilesSelectColumn["width"] = "width";
})(TranscoderProfilesSelectColumn = exports.TranscoderProfilesSelectColumn || (exports.TranscoderProfilesSelectColumn = {}));
/** update columns of table "transcoder_profiles" */
var TranscoderProfilesUpdateColumn;
(function (TranscoderProfilesUpdateColumn) {
    /** column name */
    TranscoderProfilesUpdateColumn["audio_bitrate_kbps"] = "audio_bitrate_kbps";
    /** column name */
    TranscoderProfilesUpdateColumn["created_at"] = "created_at";
    /** column name */
    TranscoderProfilesUpdateColumn["frame_rate"] = "frame_rate";
    /** column name */
    TranscoderProfilesUpdateColumn["height"] = "height";
    /** column name */
    TranscoderProfilesUpdateColumn["id"] = "id";
    /** column name */
    TranscoderProfilesUpdateColumn["includes_audio"] = "includes_audio";
    /** column name */
    TranscoderProfilesUpdateColumn["includes_video"] = "includes_video";
    /** column name */
    TranscoderProfilesUpdateColumn["name"] = "name";
    /** column name */
    TranscoderProfilesUpdateColumn["org_id"] = "org_id";
    /** column name */
    TranscoderProfilesUpdateColumn["original_file_id"] = "original_file_id";
    /** column name */
    TranscoderProfilesUpdateColumn["output_file_id"] = "output_file_id";
    /** column name */
    TranscoderProfilesUpdateColumn["status"] = "status";
    /** column name */
    TranscoderProfilesUpdateColumn["updated_at"] = "updated_at";
    /** column name */
    TranscoderProfilesUpdateColumn["video_bitrate_kbps"] = "video_bitrate_kbps";
    /** column name */
    TranscoderProfilesUpdateColumn["width"] = "width";
})(TranscoderProfilesUpdateColumn = exports.TranscoderProfilesUpdateColumn || (exports.TranscoderProfilesUpdateColumn = {}));
/** unique or primary key constraints on table "user_group_members" */
var UserGroupMembersConstraint;
(function (UserGroupMembersConstraint) {
    /** unique or primary key constraint */
    UserGroupMembersConstraint["user_group_members_pkey"] = "user_group_members_pkey";
})(UserGroupMembersConstraint = exports.UserGroupMembersConstraint || (exports.UserGroupMembersConstraint = {}));
/** select columns of table "user_group_members" */
var UserGroupMembersSelectColumn;
(function (UserGroupMembersSelectColumn) {
    /** column name */
    UserGroupMembersSelectColumn["group_id"] = "group_id";
    /** column name */
    UserGroupMembersSelectColumn["id"] = "id";
    /** column name */
    UserGroupMembersSelectColumn["user_id"] = "user_id";
})(UserGroupMembersSelectColumn = exports.UserGroupMembersSelectColumn || (exports.UserGroupMembersSelectColumn = {}));
/** update columns of table "user_group_members" */
var UserGroupMembersUpdateColumn;
(function (UserGroupMembersUpdateColumn) {
    /** column name */
    UserGroupMembersUpdateColumn["group_id"] = "group_id";
    /** column name */
    UserGroupMembersUpdateColumn["id"] = "id";
    /** column name */
    UserGroupMembersUpdateColumn["user_id"] = "user_id";
})(UserGroupMembersUpdateColumn = exports.UserGroupMembersUpdateColumn || (exports.UserGroupMembersUpdateColumn = {}));
/** unique or primary key constraints on table "user_groups" */
var UserGroupsConstraint;
(function (UserGroupsConstraint) {
    /** unique or primary key constraint */
    UserGroupsConstraint["user_groups_pkey"] = "user_groups_pkey";
})(UserGroupsConstraint = exports.UserGroupsConstraint || (exports.UserGroupsConstraint = {}));
/** select columns of table "user_groups" */
var UserGroupsSelectColumn;
(function (UserGroupsSelectColumn) {
    /** column name */
    UserGroupsSelectColumn["created_at"] = "created_at";
    /** column name */
    UserGroupsSelectColumn["id"] = "id";
    /** column name */
    UserGroupsSelectColumn["name"] = "name";
    /** column name */
    UserGroupsSelectColumn["updated_at"] = "updated_at";
})(UserGroupsSelectColumn = exports.UserGroupsSelectColumn || (exports.UserGroupsSelectColumn = {}));
/** update columns of table "user_groups" */
var UserGroupsUpdateColumn;
(function (UserGroupsUpdateColumn) {
    /** column name */
    UserGroupsUpdateColumn["created_at"] = "created_at";
    /** column name */
    UserGroupsUpdateColumn["id"] = "id";
    /** column name */
    UserGroupsUpdateColumn["name"] = "name";
    /** column name */
    UserGroupsUpdateColumn["updated_at"] = "updated_at";
})(UserGroupsUpdateColumn = exports.UserGroupsUpdateColumn || (exports.UserGroupsUpdateColumn = {}));
/** unique or primary key constraints on table "users" */
var UsersConstraint;
(function (UsersConstraint) {
    /** unique or primary key constraint */
    UsersConstraint["users_auth_user_id_key"] = "users_auth_user_id_key";
    /** unique or primary key constraint */
    UsersConstraint["users_pkey"] = "users_pkey";
})(UsersConstraint = exports.UsersConstraint || (exports.UsersConstraint = {}));
/** select columns of table "users" */
var UsersSelectColumn;
(function (UsersSelectColumn) {
    /** column name */
    UsersSelectColumn["auth_user_id"] = "auth_user_id";
    /** column name */
    UsersSelectColumn["created_at"] = "created_at";
    /** column name */
    UsersSelectColumn["email"] = "email";
    /** column name */
    UsersSelectColumn["id"] = "id";
    /** column name */
    UsersSelectColumn["is_vl_admin"] = "is_vl_admin";
    /** column name */
    UsersSelectColumn["name"] = "name";
    /** column name */
    UsersSelectColumn["photo_url"] = "photo_url";
    /** column name */
    UsersSelectColumn["updated_at"] = "updated_at";
})(UsersSelectColumn = exports.UsersSelectColumn || (exports.UsersSelectColumn = {}));
/** update columns of table "users" */
var UsersUpdateColumn;
(function (UsersUpdateColumn) {
    /** column name */
    UsersUpdateColumn["auth_user_id"] = "auth_user_id";
    /** column name */
    UsersUpdateColumn["created_at"] = "created_at";
    /** column name */
    UsersUpdateColumn["email"] = "email";
    /** column name */
    UsersUpdateColumn["id"] = "id";
    /** column name */
    UsersUpdateColumn["is_vl_admin"] = "is_vl_admin";
    /** column name */
    UsersUpdateColumn["name"] = "name";
    /** column name */
    UsersUpdateColumn["photo_url"] = "photo_url";
    /** column name */
    UsersUpdateColumn["updated_at"] = "updated_at";
})(UsersUpdateColumn = exports.UsersUpdateColumn || (exports.UsersUpdateColumn = {}));
/** unique or primary key constraints on table "video_properties" */
var VideoPropertiesConstraint;
(function (VideoPropertiesConstraint) {
    /** unique or primary key constraint */
    VideoPropertiesConstraint["video_properties_media_asset_id_key"] = "video_properties_media_asset_id_key";
    /** unique or primary key constraint */
    VideoPropertiesConstraint["video_properties_pkey"] = "video_properties_pkey";
})(VideoPropertiesConstraint = exports.VideoPropertiesConstraint || (exports.VideoPropertiesConstraint = {}));
/** select columns of table "video_properties" */
var VideoPropertiesSelectColumn;
(function (VideoPropertiesSelectColumn) {
    /** column name */
    VideoPropertiesSelectColumn["duration_in_seconds"] = "duration_in_seconds";
    /** column name */
    VideoPropertiesSelectColumn["height"] = "height";
    /** column name */
    VideoPropertiesSelectColumn["id"] = "id";
    /** column name */
    VideoPropertiesSelectColumn["media_asset_id"] = "media_asset_id";
    /** column name */
    VideoPropertiesSelectColumn["width"] = "width";
})(VideoPropertiesSelectColumn = exports.VideoPropertiesSelectColumn || (exports.VideoPropertiesSelectColumn = {}));
/** update columns of table "video_properties" */
var VideoPropertiesUpdateColumn;
(function (VideoPropertiesUpdateColumn) {
    /** column name */
    VideoPropertiesUpdateColumn["duration_in_seconds"] = "duration_in_seconds";
    /** column name */
    VideoPropertiesUpdateColumn["height"] = "height";
    /** column name */
    VideoPropertiesUpdateColumn["id"] = "id";
    /** column name */
    VideoPropertiesUpdateColumn["media_asset_id"] = "media_asset_id";
    /** column name */
    VideoPropertiesUpdateColumn["width"] = "width";
})(VideoPropertiesUpdateColumn = exports.VideoPropertiesUpdateColumn || (exports.VideoPropertiesUpdateColumn = {}));
exports.TicketOptionFragmentDoc = graphql_tag_1.default `
  fragment TicketOption on ticketing_ticket_options {
    id
    name
    price
    currency
    validUntil: valid_until
    validForUnit: valid_for_unit
    validForAmount: valid_for_amount
    ticketType: ticket_type
    contentId: content_id
  }
`;
exports.ExchangeAccessCodeDocument = graphql_tag_1.default `
  mutation ExchangeAccessCode($contentId: uuid!, $code: String!, $ip: String!) {
    invalidated: update_ticketing_access_tokens(
      where: { content_row_id: { _eq: $contentId }, code: { _eq: $code } }
      _append: { extra_data: { valid: false } }
    ) {
      tokens: returning {
        token: id
      }
    }
    tokens: insert_ticketing_access_tokens(
      objects: {
        content_row_id: $contentId
        code: $code
        ip: $ip
        extra_data: { valid: true }
      }
    ) {
      result: returning {
        token: id
      }
    }
  }
`;
exports.IsTokenValidDocument = graphql_tag_1.default `
  query IsTokenValid($token: uuid!) {
    accessToken: ticketing_access_tokens_by_pk(id: $token) {
      token: id
      code
      ip
      isValid: extra_data(path: "valid")
    }
  }
`;
exports.S3DataWarehouseDocument = graphql_tag_1.default `
  query S3DataWarehouse($warehouseId: uuid!) {
    s3: s3_data_warehouses_by_pk(id: $warehouseId) {
      id
      bucket
      accessKey: access_key
      accessSecret: access_secret
      region
      endpoint
    }
  }
`;
exports.PublishingDataDocument = graphql_tag_1.default `
  query PublishingData($projectId: uuid!) {
    project: projects_by_pk(id: $projectId) {
      id
      publishingUrl: publishing_url
      defaultLocale: default_locale
      locales
      slug
      organization {
        slug
      }
    }
    schemas: cms_content_schemas(
      where: { project_id: { _eq: $projectId } }
      order_by: { updated_at: desc }
      limit: 1
    ) {
      id
      sdl: schema_sdl
      version
    }
    contentData: cms_content_rows(
      where: {
        _and: [
          { project_id: { _eq: $projectId } }
          { deleted_at: { _is_null: true } }
        ]
      }
    ) {
      id
      type
      isAccessRestricted: is_access_restricted
      localeData: locale_data
      version
      status
    }
    latestPublications: cms_publications(
      where: { project_id: { _eq: $projectId } }
      order_by: { created_at: desc }
      limit: 1
    ) {
      id
      version
    }
    accessCodes: ticketing_access_codes(
      where: { content_row: { project_id: { _eq: $projectId } } }
    ) {
      id
      codes
      contentId: content_row_id
    }
    ticketOptions: ticketing_ticket_options(
      where: { content_row: { project_id: { _eq: $projectId } } }
    ) {
      ...TicketOption
    }
  }
  ${exports.TicketOptionFragmentDoc}
`;
exports.PublishDataDocument = graphql_tag_1.default `
  mutation PublishData(
    $projectId: uuid!
    $publishedData: jsonb!
    $schemaSdl: String!
    $version: String!
    $publishingUrl: String!
    $contentIds: [uuid!]!
  ) {
    insert_cms_publications(
      objects: {
        project_id: $projectId
        published_data: $publishedData
        schema_sdl: $schemaSdl
        version: $version
        publishing_webhook_url: $publishingUrl
      }
    ) {
      returning {
        id
      }
    }
    deletedRows: delete_cms_content_rows(
      where: { deleted_at: { _is_null: false } }
    ) {
      total: affected_rows
    }
    updatedRows: update_cms_content_rows(
      where: { id: { _in: $contentIds } }
      _set: { status: "PUBLISHING", version: $version, revision: "PUBLISHER" }
    ) {
      total: affected_rows
    }
  }
`;
const defaultWrapper = sdkFunction => sdkFunction();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        ExchangeAccessCode(variables) {
            return withWrapper(() => client.request(graphql_1.print(exports.ExchangeAccessCodeDocument), variables));
        },
        IsTokenValid(variables) {
            return withWrapper(() => client.request(graphql_1.print(exports.IsTokenValidDocument), variables));
        },
        S3DataWarehouse(variables) {
            return withWrapper(() => client.request(graphql_1.print(exports.S3DataWarehouseDocument), variables));
        },
        PublishingData(variables) {
            return withWrapper(() => client.request(graphql_1.print(exports.PublishingDataDocument), variables));
        },
        PublishData(variables) {
            return withWrapper(() => client.request(graphql_1.print(exports.PublishDataDocument), variables));
        },
    };
}
exports.getSdk = getSdk;
//# sourceMappingURL=data:application/json;base64,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